import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "../Companies/Companies.css";
import Header from "../Header/Header";
import SidebarFilter from "../Companies/SidebarFilter";
import { FaLinkedin } from "react-icons/fa";
import { MdClose } from "react-icons/md";
import { VscPass } from "react-icons/vsc";
import { VscError } from "react-icons/vsc";
import * as XLSX from "xlsx";
import { IoMdDownload } from "react-icons/io";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { GiCampfire } from "react-icons/gi";
import { CiEdit } from "react-icons/ci";
import idea1 from "../../assets/Images/revenue_logo.jpg";
import { IoIosExpand } from "react-icons/io";
import { MdDelete } from "react-icons/md";
import { MdOutlineMailOutline } from "react-icons/md";
import Swal from "sweetalert2";
import { IoLockOpen } from "react-icons/io5";
import EmptyImage from "../../assets/Images/no-image.png";
import { IoMdMail } from "react-icons/io";
import html2canvas from "html2canvas";
import Not_Verified from "../../assets/Images/NotVerified.png";
import Verified from "../../assets/Images/Verified.png";
import Expiring from "../../assets/Images/Expiring.png";
import { fetchResearcherDetails} from "../../api/index";
import { useResearcher } from "../../context/ResearcherContext";

const requiredHeaders = [
  "First name",
  "Company Name",
  "Email",
  "Linkedin",
  "Designation",
  "Phone Number",
  "Website",
  "City",
  "State",
  "Country",
  "Industry",
  "Company Description",
  "Followers",
  "Technology Details",
  "Annual Revenue",
  "No of Employees",
  "Company Location",
  "Headquarter",
  "Sub Category",
  "Type of Customer",
  "Financial",
  "Investors",
  "Job Openings",
  "News and Social insights",
  "Competitors",
  "Partners",
  "Status"
];

const Contacts = () => {
  const baseURL =
    process.env.NODE_ENV === "production"
      ? process.env.REACT_APP_API_URL_PROD
      : process.env.REACT_APP_API_URL_LOCAL;

  //open add details popup
  const [isAdd, setIsAdd] = useState(false);

  //for post details
  const [details, setDetails] = useState({
    firstname: "",
    companyname: "",
    linkedin: "",
    email: "",
    designation: "",
    phonenumber: "",
    image: "",
    website: "",
    city: "",
    state: "",
    country: "",
    annualrevenue: "",
    noofemployees: "",
    companylocation: "",
    industry: "",
    headquarter: "",
    subcategory: "",
    typeofCustomer: "",
    companydescription: "",
    technologydetails: "",
    jobopenings: [{ jobname: "", jobdescription: "", jobsource: "" }],
    newsandsocialinsights: [
      { newsname: "", newsdescription: "", newssource: "" },
    ],
    financial: [
      { financialdescription: "", financialsourcelink: "", financialyear: "" },
    ],
    investors: [{ investors: "", investorsourcelink: "" }],
    competitors: "",
    partners: "",
    status: ""
  });

  const navigate = useNavigate();

  const [selectedFilters, setSelectedFilters] = useState({
    mycontacts: [],
    companyname: [],
    industry: [],
    designation: [],
    status:[],
    noofemployees: [],
    companylocation: [],
    annualrevenue: [],
    subcategory: [],
  });
  const [activeContainer, setActiveContainer] = useState("singleRequests");
  const [filteredData, setFilteredData] = useState(null);

  const handleSetActive = (containerName) => {
    setActiveContainer(containerName);
  };

  //store details in the state
  const [data, setData] = useState([]);
  const [research, setResearch] = useState([]);
  //count peoples
  const [count, setCount] = useState(0);
  const [selectedUserId, setSelectedUserId] = useState(null);

  //Profile popup
  const [isOpenProfile, setIsOpenProfile] = useState(false);

  //for search data
  const [searchData, setSearchData] = useState("");
  //table pagination
  const [currentPage, setCurrentPage] = useState(1);

  //expand selected profile
  const [selectedItem, setSelectedItem] = useState(null);

  //show company details
  const [showCompany, setShowCompany] = useState(true);

  //show job openings
  const [showOpenings, setShowOpenings] = useState(false);
  const [showTechstack, setShowTechstack] = useState(false);
  const [showAccount, setShowAccount] = useState(false);
  const [showContact, setShowContact] = useState(false);

  //change background color on click
  const [companyColor, setCompanyColor] = useState("#FCB124");
  const [jobColor, setJobColor] = useState("");
  const [techColor, setTechColor] = useState("");
  const [contactColor, setContactColor] = useState("");
  const [accountColor, setAccountColor] = useState("");
  const [visibleNews, setVisibleNews] = useState(3);

  // const [isDownload, setIsDownload] = useState(false);
  // const [fileType, setFileType] = useState('');

  const [uploadFile, setUploadFile] = useState(null);
  const [excelHeaders, setExcelHeaders] = useState([]);
  const [selectedFields, setSelectedFields] = useState({});
  const [showPopup, setShowPopup] = useState(false);

  const [editMode, setEditMode] = useState(false);

  const [visibleColumns, setVisibleColumns] = useState({});

  //select checkbox for download file
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectAll, setSelectAll] = useState();

  const [showMissingFieldsPopup, setShowMissingFieldsPopup] = useState(false);
  const [missingFields, setMissingFields] = useState([]);

  const [isMyContacts, setIsMyContacts] = useState(false);
  const [isContacts, setIsContacts] = useState(true);

  const [role, setRole] = useState("");
  const [file, setFile] = useState(null);

  const [singleRequests, setSingleRequests] = useState([]);
  const [bulkRequests, setBulkRequests] = useState([]);
  const [researchRequest, setResearchRequest] = useState([]);
  const [dataRequest, setDataRequest] = useState([]);

  const [isSingleRequests, setIsSingleRequests] = useState(false);
  const [isBulkRequests, setIsBulkRequests] = useState(false);
  const [isResearchRequests, setIsResearchRequests] = useState(false);
  const [isDataRequest, setIsDataRequest] = useState(false);
  const [isEditRequest, setIsEditRequest] = useState(true);

  const [editRequest, setEditRequest] = useState([]);

  //credits count
  const [credits, setCredits] = useState(0);
  const [spentCredits, setSpentCredits] = useState(0);
  const [remainingCredits, setRemainingCredits] = useState(0);

  const [currentChunkIndex, setCurrentChunkIndex] = useState(0);

  const [showForm, setShowForm] = useState(false);
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [formData, setFormData] = useState({
    firstname: "",
    companyname: "",
    linkedin: "",
    email: "",
    designation: "",
    phonenumber: "",
    image: "",
    website: "",
    city: "",
    state: "",
    country: "",
    annualrevenue: "",
    noofemployees: "",
    companylocation: "",
    industry: "",
    headquarter: "",
    subcategory: "",
    typeofCustomer: "",
    companydescription: "",
    followers: "",
    technologydetails: "",
    jobopenings: [{ jobname: "", jobdescription: "", jobsource: "" }],
    newsandsocialinsights: [
      { newsname: "", newsdescription: "", newssource: "" },
    ],
    financial: [
      { financialdescription: "", financialsourcelink: "", financialyear: "" },
    ],
    investors: [{ investors: "", investorsourcelink: "" }],
    competitors: "",
    partners: "",
    status: "Pending",
  });

  const [isResearch, setIsResearch] = useState(false);
  const [requests, setRequests] = useState([]);

  const [extraFields, setExtraFields] = useState([{ label: "", value: "" }]);
  const [newFieldLabel, setNewFieldLabel] = useState("");
  const [showLabelInput, setShowLabelInput] = useState(false);
  const [expandedNewsIndex, setExpandedNewsIndex] = useState(null);
  const [expandedJobIndex, setExpandedJobIndex] = useState(null);

  //For table designation
  const [listName, setListName] = useState("");
  const [userlists, setuserlists] = useState(false);
  const [selectedListName, setSelectedListName] = useState(null);
  const [viewedProfiles, setViewedProfiles] = useState([]);


const itemsPerPage = 10;
const chunkSize = 50;

const [page, setPage] = useState(1);
const [allDataCount, setAllDataCount] = useState(0);
const [totalCount, setTotalCount] = useState(0);
const [userData, setUserData] = useState([])

  useEffect(() => {
    const userRole = localStorage.getItem("role");
    setRole(userRole);
  }, []);

  const [isLoading, setIsLoading] = useState(false);
  const [adminId, setAdminId] = useState(null);
  const { researcherId } = useResearcher();

  useEffect(() => {
    const fetchAdminId = async () => {
      try {
        const response = await axios.get(`${baseURL}/api/getadminid`);
        setAdminId(response.data.adminId);
      } catch (err) {
        console.error(
          "Failed to fetch admin ID:",
          err.response?.data?.message || err.message
        );
      }
    };

    fetchAdminId();
  }, []);

  useEffect(() => {}, [selectedRequest, showForm]);

const fetchResearcher = async (chunkIndex) => {
  setCurrentChunkIndex(chunkIndex);
  setIsLoading(true);
  const skip = chunkIndex * chunkSize || 0;
  const limit = chunkSize;
  const token = localStorage.getItem("token");

  if (!token) {
    console.error("No token found.");
    return;
  }

  try {
    const data = await fetchResearcherDetails(researcherId, skip, limit);
 
    const chunkData = data?.researcherData?.details || [];

    setData((prev) => ({
      ...prev,
      [chunkIndex]: chunkData,
    }));
    setSingleRequests(data.researcherData.singleRequest);
    setBulkRequests(data.researcherData.bulkRequests);
    setResearchRequest(data.researcherData.researchRequest);
    setDataRequest(data.researcherData.dataRequest);
    setEditRequest(data.researcherData.editRequests);
    setAllDataCount(data.totalCount);
    setTotalCount(data.totalCount);
     setIsLoading(false);
  } catch (error) {
    console.error("Error fetching chunk:", error);
  }
};

useEffect(() => {
  let result = [];

  if (isFilterApplied) {
    const allDetails = Array.isArray(filteredData)
      ? filteredData.flatMap((item) => item.details || [])
      : [];

    result = allDetails.filter((item) =>
      Object.entries(selectedFilters).every(([key, values]) => {
        if (values.length === 0) return true;
        if (key === "updatedAt") {
          const itemDate = item.updatedAt?.slice(0, 10);
          return values.includes(itemDate);
        }
        return values.includes(item[key]);
      })
    );

    if (hasSearch) {
      const term = searchData.toLowerCase();
      result = result.filter((item) =>
        Object.values(item).some((val) =>
          val?.toString().toLowerCase().includes(term)
        )
      );
        setTotalCount(result.length);
    }
  } else {
    const chunkIndex = Math.floor((currentPage - 1) / (chunkSize / itemsPerPage));
    const chunkData = data[chunkIndex] || [];

    result = hasSearch
      ? chunkData.filter((item) =>
          Object.values(item).some((val) =>
            val?.toString().toLowerCase().includes(searchData.toLowerCase())
          )
        )
      : chunkData;
      setTotalCount(allDataCount);
  }

}, [filteredData, selectedFilters, searchData, data, currentPage]);

useEffect(() => {
  const chunkIndex = Math.floor((currentPage - 1) / (chunkSize / itemsPerPage));
  if(researcherId){
     if (!data[chunkIndex]) {
    fetchResearcher(chunkIndex);
  }
  }
 
}, [researcherId, currentPage,]);

useEffect(() => {
  const prefetchIndex = Math.floor(page / (chunkSize / itemsPerPage));
  if(researcherId){
    if (!data[prefetchIndex]) {
    fetchResearcher(prefetchIndex);
  }
  }
}, [page]);

  const handleOnChange = (e) => {
    const { name, value } = e.target;
    setDetails((prevDetails) => ({
      ...prevDetails,
      [name]: value,
    }));
  };

  // useEffect(() => {
  //   if (!data) return;

  //   let filtered = [...data];

  //   Object.entries(selectedFilters).forEach(([field, selectedValues]) => {
  //     if (selectedValues.length > 0) {
  //       filtered = filtered.filter((item) =>
  //         selectedValues.includes(item[field])
  //       );
  //     }
  //   });
  // }, [data, selectedFilters]);

  const handleCloseOverlay = () => {
    if (isAdd) {
      setIsAdd(false);
    } else if (editMode) {
      setEditMode(false);
    }
    setSelectedRows([]);
    setDetails({
      firstname: "",
      companyname: "",
      linkedin: "",
      email: "",
      designation: "",
      phonenumber: "",
      website: "",
      city: "",
      state: "",
      country: "",
      annualrevenue: "",
      noofemployees: "",
      companylocation: "",
      industry: "",
      headquarter: "",
      subcategory: "",
      typeofCustomer: "",
      companydescription: "",
      technologydetails: "",
      jobopenings: [{ jobname: "", jobdescription: "", jobsource: "" }],
      newsandsocialinsights: [
        { newsname: "", newsdescription: "", newssource: "" },
      ],
      financial: [
        {
          financialdescription: "",
          financialsourcelink: "",
          financialyear: "",
        },
      ],
      investors: [{ investors: "", investorsourcelink: "" }],
      competitors: "",
      partners: "",
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const token = localStorage.getItem("token");
    const userId = localStorage.getItem("userId");
    const userName = localStorage.getItem("name");
    const userEmail = localStorage.getItem("email");

    if (!token) {
      Swal.fire({
        icon: "error",
        title: "error",
        text: "You need to login first",
      });
      return navigate("/");
    }

    try {
      const apiUrl = `${baseURL}/api/researcher`;

      let response;

      const requestBody = {
        updatedDetails: details,
        userId,
        userName,
        userEmail,
        researcherId,
      };

      if (editMode) {
        response = await axios.put(
          `${apiUrl}/update/${details._id}`,
          requestBody,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
      } else {
        response = await axios.post(apiUrl, details, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });
      }
      if (editMode) {
        Swal.fire({
          icon: "success",
          title: "Contact updated successfully",
          confirmButtonColor: "#FCB124",
          confirmButtonText: "OK",
        });
      } else {
        Swal.fire({
          icon: "success",
          title: "Contact added successfully",
          confirmButtonColor: "#FCB124",
          confirmButtonText: "OK",
        });
      }

      // Reset Form
      setDetails({
        firstname: "",
        companyname: "",
        linkedin: "",
        email: "",
        designation: "",
        phonenumber: "",
        website: "",
        city: "",
        state: "",
        country: "",
        annualrevenue: "",
        noofemployees: "",
        companylocation: "",
        industry: "",
        headquarter: "",
        subcategory: "",
        typeofCustomer: "",
        companydescription: "",
        technologydetails: "",
        jobopenings: [{ jobname: "", jobdescription: "", jobsource: "" }],
        newsandsocialinsights: [
          { newsname: "", newsdescription: "", newssource: "" },
        ],
        financial: [
          {
            financialdescription: "",
            financialsourcelink: "",
            financialyear: "",
          },
        ],
        investors: [{ investors: "", investorsourcelink: "" }],
        competitors: "",
        partners: "",
        ...(editMode && { updatedAt: new Date() }),
      });
      setIsAdd(false);
      setEditMode(false);
      setSelectedRows([]);
      fetchResearcher();
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Internal Server Error",
        text: "Error",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "OK",
      });
    }
  };

  useEffect(() => {
    if (research.extraFields && research.extraFields.length > 0) {
      setExtraFields(research.extraFields);
    } else {
      setExtraFields([]);
    }
  }, [research]);

  const handleFinanceChange = (e, index, field) => {
    const newFinancialDetails = [...details.financial];
    newFinancialDetails[index][field] = e.target.value;
    setDetails({ ...details, financial: newFinancialDetails });
  };

  const addFinancial = () => {
    setDetails({
      ...details,
      financial: [
        ...details.financial,
        { financialdescription: "", financesourcelink: "", financialyear: "" },
      ],
    });
  };

  const removeFinancial = (index) => {
    const newFinancialDetails = details.financial.filter((_, i) => i !== index);
    setDetails({ ...details, financial: newFinancialDetails });
  };

  const handleInvestorChange = (e, index, field) => {
    const newInvestorDetails = [...details.investors];
    newInvestorDetails[index][field] = e.target.value;
    setDetails({ ...details, investors: newInvestorDetails });
  };

  const addInvestor = () => {
    setDetails({
      ...details,
      investors: [
        ...details.investors,
        { investors: "", investorsourcelink: "" },
      ],
    });
  };

  const removeInvestor = (index) => {
    const newInvestorDetails = details.investors.filter((_, i) => i !== index);
    setDetails({ ...details, investors: newInvestorDetails });
  };

  const handleJobChange = (e, index, field) => {
    const newJobOpenings = [...details.jobopenings];
    newJobOpenings[index][field] = e.target.value;
    setDetails({ ...details, jobopenings: newJobOpenings });
  };

  const addJobOpening = () => {
    setDetails({
      ...details,
      jobopenings: [
        ...details.jobopenings,
        { jobname: "", jobdescription: "", jobsource: "" },
      ],
    });
  };

  const removeJobOpening = (index) => {
    const newJobOpenings = details.jobopenings.filter((_, i) => i !== index);
    setDetails({ ...details, jobopenings: newJobOpenings });
  };

  const handleNewsChange = (e, index, field) => {
    const newNews = [...details.newsandsocialinsights];
    newNews[index][field] = e.target.value;
    setDetails({ ...details, newsandsocialinsights: newNews });
  };

  const addNews = () => {
    setDetails({
      ...details,
      newsandsocialinsights: [
        ...details.newsandsocialinsights,
        { newsname: "", newsdescription: "", newssource: "" },
      ],
    });
  };

  const removeNews = (index) => {
    const newNews = details.newsandsocialinsights.filter((_, i) => i !== index);
    setDetails({ ...details, newsandsocialinsights: newNews });
  };

  const handleFinanceFormChange = (e, index, field) => {
    const newFinancialDetails = [...formData.financial];
    newFinancialDetails[index][field] = e.target.value;
    setFormData({ ...formData, financial: newFinancialDetails });
  };

  const addFinancialForm = () => {
    setFormData({
      ...formData,
      financial: [
        ...formData.financial,
        { financialdescription: "", financesourcelink: "", financialyear: "" },
      ],
    });
  };

  const removeFinancialForm = (index) => {
    const newFinancialDetails = formData.financial.filter(
      (_, i) => i !== index
    );
    setFormData({ ...formData, financial: newFinancialDetails });
  };

  const handleInvestorFormChange = (e, index, field) => {
    const newInvestorDetails = [...formData.investors];
    newInvestorDetails[index][field] = e.target.value;
    setFormData({ ...formData, investors: newInvestorDetails });
  };

  const addInvestorForm = () => {
    setFormData({
      ...formData,
      investors: [
        ...formData.investors,
        { investors: "", investorsourcelink: "" },
      ],
    });
  };

  const removeInvestorForm = (index) => {
    const newInvestorDetails = formData.investors.filter((_, i) => i !== index);
    setFormData({ ...formData, investors: newInvestorDetails });
  };

  const handleJobFormChange = (e, index, field) => {
    const newJobOpenings = [...formData.jobopenings];
    newJobOpenings[index][field] = e.target.value;
    setFormData({ ...formData, jobopenings: newJobOpenings });
  };

  const addJobOpeningForm = () => {
    setFormData({
      ...formData,
      jobopenings: [
        ...formData.jobopenings,
        { jobname: "", jobdescription: "", jobsource: "" },
      ],
    });
  };

  const removeJobOpeningForm = (index) => {
    const newJobOpenings = formData.jobopenings.filter((_, i) => i !== index);
    setFormData({ ...formData, jobopenings: newJobOpenings });
  };

  const handleNewsFormChange = (e, index, field) => {
    const newNews = [...formData.newsandsocialinsights];
    newNews[index][field] = e.target.value;
    setFormData({ ...formData, newsandsocialinsights: newNews });
  };

  const addNewsForm = () => {
    setFormData({
      ...formData,
      newsandsocialinsights: [
        ...formData.newsandsocialinsights,
        { newsname: "", newsdescription: "", newssource: "" },
      ],
    });
  };

  const removeNewsForm = (index) => {
    const newNews = formData.newsandsocialinsights.filter(
      (_, i) => i !== index
    );
    setFormData({ ...formData, newsandsocialinsights: newNews });
  };

  const handleShowMoreNews = () => {
    setVisibleNews((prev) => prev + 3);
  };

  const saveCreditsToDB = async (credits, spentcredits, remainingcredits) => {
    const userId = localStorage.getItem("userId");
    const token = localStorage.getItem("token");
    try {
      const response = await fetch(`${baseURL}/api/update-credits/${userId}`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ credits, spentcredits, remainingcredits }),
      });

      const data = await response.json();
    } catch (error) {
      console.error("Error saving credits:", error);
    }
  };

let isFilterApplied = Object.values(selectedFilters).some((arr) => arr.length > 0);
const hasSearch = searchData && searchData.trim().length > 0;

let paginatedData = [];

if (isFilterApplied) {

  const allDetails = Array.isArray(filteredData)
    ? filteredData.flatMap((item) => item.details || [])
    : [];

  let matchingDetails = allDetails.filter((item) =>
    Object.entries(selectedFilters).every(([key, values]) => {
      if (values.length === 0) return true;

      if (key === "updatedAt") {
        const itemDate = item.updatedAt?.slice(0, 10);
        return values.includes(itemDate);
      }

      return values.includes(item[key]);
    })
  );

  if (hasSearch) {
    const searchTerm = searchData.toLowerCase();
    matchingDetails = matchingDetails.filter((item) =>
      Object.values(item).some((val) =>
        val?.toString().toLowerCase().includes(searchTerm)
      )
    );
  }

  const start = (currentPage - 1) * itemsPerPage;
  const end = start + itemsPerPage;
  paginatedData = matchingDetails.slice(start, end);
} else {
  const chunkIndex = Math.floor((currentPage - 1) / (chunkSize / itemsPerPage));
  const chunkData = data[chunkIndex] || [];

let visibleData = Array.isArray(chunkData) ? chunkData : [];

  if (hasSearch) {
    const searchTerm = searchData.toLowerCase();
    visibleData = chunkData.filter((item) =>
      Object.values(item).some((val) =>
        val?.toString().toLowerCase().includes(searchTerm)
      )
    );
  }

  const localPage = (currentPage - 1) % (chunkSize / itemsPerPage);
  const start = localPage * itemsPerPage;
  const end = start + itemsPerPage;

  paginatedData = visibleData.slice(start, end);

}

const totalPages = Math.ceil(totalCount / itemsPerPage);

  useEffect(() => {
    if (!paginatedData.length) return;

    const columnsVisibility = Object.keys(paginatedData[0]).reduce(
      (acc, key) => {
        acc[key] = paginatedData.some((item) => item[key]);
        return acc;
      },
      {}
    );

    setVisibleColumns((prevColumns) =>
      JSON.stringify(prevColumns) !== JSON.stringify(columnsVisibility)
        ? columnsVisibility
        : prevColumns
    );
  }, [paginatedData, selectedFilters]);

  const goToPage = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };
  
//   const goToPage = (pageNumber) => {
//   if (pageNumber < 1) return;
//   setPage(pageNumber);
// };

  const handleEdit = (id) => {
    const itemToEdit = data.find((item) => item._id === id);
    if (itemToEdit) {
      setDetails(itemToEdit);
      setEditMode(true);
      setIsAdd(false);
    }
  };

  const handleDelete = async (e) => {
    e.preventDefault();
    if (selectedRows.length === 0) {
      Swal.fire({
        icon: "warning",
        title: "No Selection",
        text: "Please select at least one entry to delete.",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "OK",
      });
      return;
    }
    const token = localStorage.getItem("token");
    const deleteUrl = `${baseURL}/api/delete-researcher-details`;
    try {
      const response = await fetch(deleteUrl, {
        method: "DELETE",
        headers: { 
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
         },
        body: JSON.stringify({ ids: selectedRows }),
      });

     if (response.ok) {
  setData((prevData) => {
    const updatedData = { ...prevData };
    Object.keys(updatedData).forEach((chunkKey) => {
      updatedData[chunkKey] = updatedData[chunkKey].filter(
        (item) => !selectedRows.includes(item._id)
      );
    });

    return updatedData;
  });

  fetchResearcher(0); 

  setSelectedRows([]);
  setSelectAll(false); 
  Swal.fire({
    icon: "success",
    title: "Contacts deleted Successfully",
    confirmButtonColor: "#FCB124",
  });


       
      } else {
        Swal.fire({
          icon: "error",
          title: "Failed to delete contact(s)",
          confirmButtonColor: "#FCB124",
        });
        setSelectedRows([]);
        setSelectAll();
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Something went wrong!",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "OK",
      });
    }
  };

  const handleShowCompany = () => {
    setCompanyColor("#FCB124");
    setContactColor("#fff");
    setJobColor("#fff");
    setTechColor("#fff");
    setAccountColor("#fff");
    setShowCompany(true);
    setShowTechstack(false);
    setShowAccount(false);
    setShowContact(false);
    setShowOpenings(false);
  };

  const handleShowTechStack = () => {
    setCompanyColor("#fff");
    setTechColor("#FCB124");
    setContactColor("#fff");
    setJobColor("#fff");
    setAccountColor("#fff");
    setShowTechstack(true);
    setShowAccount(false);
    setShowCompany(false);
    setShowContact(false);
    setShowOpenings(false);
  };

  const handleShowContact = () => {
    setContactColor("#FCB124");
    setCompanyColor("#fff");
    setTechColor("#fff");
    setJobColor("#fff");
    setAccountColor("#fff");
    setShowCompany(false);
    setShowAccount(false);
    setShowTechstack(false);
    setShowContact(true);
    setShowOpenings(false);
  };

  const handleShowAccount = () => {
    setContactColor("#fff");
    setCompanyColor("#fff");
    setTechColor("#fff");
    setJobColor("#fff");
    setAccountColor("#FCB124");
    setShowAccount(true);
    setShowCompany(false);
    setShowTechstack(false);
    setShowContact(false);
    setShowOpenings(false);
  };

  const handleCloseProfile = () => {
    setIsOpenProfile(false);
  };

  const getStatusprofile = (status) => {
    return status === "Active"
      ? "status-active-profile"
      : "status-inactive-profile";
  };

  const handleShowOpenings = (e) => {
    e.stopPropagation();
    setJobColor("#FCB124");
    setCompanyColor("#fff");
    setContactColor("#fff");
    setAccountColor("#fff");
    setTechColor("#fff");
    setShowAccount(false);
    setShowCompany(false);
    setShowContact(false);
    setShowTechstack(false);
    setShowOpenings(true);
  };

  const downloadPDF = (companyId) => {
    if (!companyId) {
      Swal.fire({
        icon: "info",
        title: "No Selection",
        text: "No company selected for download!",
      });
      return;
    }

    const selectedCompany = paginatedData.find(
      (item) => item._id === companyId
    );
    if (!selectedCompany) {
      Swal.fire({
        icon: "info",
        title: "Not Found",
        text: "Company not found!",
      });
      return;
    }

    const doc = new jsPDF();
    let y = 10;

    const checkPageSpace = (extraHeight = 10) => {
      if (y + extraHeight > 270) {
        doc.addPage();
        y = 10;
      }
    };

    const addTextBlock = (label, text) => {
      doc.setFont("Times New Roman", "bold");
      doc.text(label, 14, y);
      y += 5;
      doc.setFont("Times New Roman", "normal");
      const lines = doc.splitTextToSize(text || "N/A", 180);
      checkPageSpace(lines.length * 7);
      doc.text(lines, 14, y);
      y += lines.length * 7;
    };

    // 1️⃣ Title
    doc.setFont("Times New Roman", "bold");
    doc.setFontSize(16);
    doc.text("Company Profile Report", 14, y);
    y += 10;

    // 2️⃣ Company Information
    doc.setFontSize(12);
    doc.setFont("Times New Roman", "normal");
    doc.text(`Company Name: ${selectedCompany.companyname || "N/A"}`, 14, y);
    y += 10;
    doc.text(`Website: ${selectedCompany.website || "N/A"}`, 14, y);
    y += 10;

    addTextBlock("Headquarter:", selectedCompany.headquarter);

    // 3️⃣ Business Description
    addTextBlock("Business Description:", selectedCompany.companydescription);

    // 4️⃣ Industry Details
    checkPageSpace(40);
    doc.setFont("Times New Roman", "bold");
    doc.text("Industry Details", 14, y);
    y += 5;
    doc.autoTable({
      startY: y,
      head: [["Category", "Value"]],
      body: [
        ["Industry", selectedCompany.industry || "N/A"],
        ["Annual Revenue", selectedCompany.annualrevenue || "N/A"],
        ["No. of Employees", selectedCompany.noofemployees || "N/A"],
        ["Type of Customer", selectedCompany.typeofcustomer || "N/A"],
      ],
    });
    y = doc.autoTable.previous.finalY + 10;

    // 5️⃣ Financial Information
    doc.setFont("Times New Roman", "bold");
    doc.text("Financial Information", 14, y);
    y += 5;
    doc.setFont("Times New Roman", "normal");

    let splitFinance = doc.splitTextToSize(
      selectedCompany.financial?.financialdescription || "N/A",
      180
    );
    checkPageSpace(splitFinance.length * 7);
    doc.text(splitFinance, 14, y);
    y += splitFinance.length * 7;

    doc.text(
      `Financial Source: ${
        selectedCompany.financial?.financialsourcelink || "N/A"
      }`,
      14,
      y
    );
    y += 10;

    doc.text(
      `Financial Year: ${selectedCompany.financial?.financialyear || "N/A"}`,
      14,
      y
    );
    y += 10;

    doc.autoTable({
      startY: y,
      head: [["Metric", "Value"]],
      body: [
        ["Investors", selectedCompany.investors?.investors || "N/A"],
        [
          "Investor Description",
          selectedCompany.investors?.investordescription || "N/A",
        ],
      ],
    });
    y = doc.autoTable.previous.finalY + 10;

    // 6️⃣ Technology Details
    doc.setFont("Times New Roman", "bold");
    doc.text("Technology Details:", 14, y);
    y += 5;
    doc.setFont("Times New Roman", "normal");

    const techDetails = selectedCompany.technologydetails || "N/A";
    const techLines = doc.splitTextToSize(techDetails, 180);
    checkPageSpace(techLines.length * 7);
    doc.text(techLines, 14, y);
    y += techLines.length * 7;

    // 7️⃣ Job Openings
    doc.setFont("Times New Roman", "bold");
    doc.text("Job Openings", 14, y);
    y += 5;
    doc.setFont("Times New Roman", "normal");

    doc.text(`Job Title: ${selectedCompany.job?.jobname || "N/A"}`, 14, y);
    y += 10;

    const jobDescLines = doc.splitTextToSize(
      selectedCompany.job?.jobdescription || "N/A",
      180
    );
    doc.text("Job Description:", 14, y);
    y += 5;
    doc.text(jobDescLines, 14, y);
    y += jobDescLines.length * 7;

    checkPageSpace(10);
    doc.text(`Job Link: ${selectedCompany.job?.jobsource || "N/A"}`, 14, y);

    // 8️⃣ Save PDF
    doc.save(`${selectedCompany.companyname}_Profile.pdf`);
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const allowedTypes = [
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "application/vnd.ms-excel",
    ];

    if (!allowedTypes.includes(file.type)) {
      Swal.fire({
        icon: "info",
        title: "Invalid File",
        text: "Please upload a valid Excel file (.xlsx or .xls)!",
      });
      return;
    }

    setUploadFile(file);
    setSelectedFields({});
  };

  // Handle file upload
  const handleUpload = async () => {
    if (!uploadFile) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please select a file first!",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "OK",
      });
      return;
    }

    const reader = new FileReader();
    reader.onload = async (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];

      const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
      let headers = jsonData[0] || [];

      // Ensure headers are strings, trimmed, and converted to lowercase
      headers = headers.map((header) =>
        header ? header.toString().trim() : ""
      );

      if (headers.length === 0) {
        Swal.fire({
          icon: "info",
          title: "Empty File",
          text: "The uploaded file is empty or does not contain headers.",
          confirmButtonText: "OK",
          confirmButtonColor: "#FCB124",
        });
        return;
      }

      setExcelHeaders(headers);
      setShowPopup(true);
    };

    reader.readAsArrayBuffer(uploadFile);
  };

  // Handle field mapping
  const handleMappingChange = (uploadedHeader, selectedValue) => {
    setSelectedFields((prevMapping) => {
      const updatedMapping = { ...prevMapping };

      if (selectedValue) {
        updatedMapping[uploadedHeader] = selectedValue;
      } else {
        delete updatedMapping[uploadedHeader];
      }

      return updatedMapping;
    });
  };

  // Function to Cancel Upload
  const handleCancelUpload = () => {
    setShowMissingFieldsPopup(false);
  };

  const handleProceedUpload = async () => {
    setShowMissingFieldsPopup(false);
    const token = localStorage.getItem("token");

    if (!token) {
      Swal.fire({
        icon: "error",
        title: "Authentication Error",
        text: "You need to log in again.",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "OK",
      });
      return;
    }

    if (!uploadFile) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please select a file first!",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "OK",
      });
      return;
    }

    const reader = new FileReader();
    reader.readAsBinaryString(uploadFile);

    reader.onloadend = async (e) => {
      try {
        const data = e.target.result;
        const workbook = XLSX.read(data, { type: "binary" });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];

        let jsonData = XLSX.utils.sheet_to_json(worksheet);

        if (jsonData.length === 0) {
          Swal.fire({
            icon: "error",
            title: "Empty File",
            text: "The uploaded file is empty!",
          });
          return;
        }

        const formattedData = jsonData.map((row) => ({
          firstname: row["First Name"]?.trim() || "",
          companyname: row["Company Name"]?.trim() || "",
          linkedin: row["LinkedIn"]?.trim() || "",
          email: row["Email"]?.trim() || "",
          designation: row["Designation"]?.trim() || "",
          phonenumber: row["Phone Number"]?.trim() || "",
          website: row["Website"]?.trim() || "",
          city: row["City"]?.trim() || "",
          state: row["State"]?.trim() || "",
          country: row["Country"]?.trim() || "",
          annualrevenue: row["Annual Revenue"]?.trim() || "",
          noofemployees: row["No of Employees"] || "",
          companylocation: row["Company Location"]?.trim() || "",
          industry: row["Industry"]?.trim() || "",
          headquarter: row["Headquarter"]?.trim() || "",
          subcategory: row["Subcategory"]?.trim() || "",
          typeofcustomer: row["Type of Customer"]?.trim() || "",
          companydescription: row["Company Description"]?.trim() || "",
          followers: row["Followers"] || "",
          technologydetails: row[" Technology Details"]?.trim() || "",
          competitors: row["Competitors"]?.trim() || "",
          partners: row["Partners"]?.trim() || "",
          jobopenings: row["Job Openings"]
            ? parseExcelDetails(row["Job Openings"], "jobopenings")
            : [],
          newsandsocialinsights: row["News and Social Insights"]
            ? parseExcelDetails(
                row["News and Social Insights"],
                "newsandsocialinsights"
              )
            : [],
          financial: row["Financial"]
            ? parseExcelDetails(row["Financial"], "financial")
            : [],
          investors: row["Investors"]
            ? parseExcelDetails(row["Investors"], "investors")
            : [],
          status: row["Status"]?.trim() || "",
        }));

        const formData = new FormData();
        formData.append("file", uploadFile);
        formData.append("data", JSON.stringify(formattedData));
        formData.append("selectedFields", JSON.stringify(selectedFields));
        formData.append("confirmUpload", true);
        formData.append("researcherId", researcherId);
        formData.append("adminId", adminId);
        formData.append("listName", selectedListName);

        const response = await fetch(`${baseURL}/api/upload-researcher-excel`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: formData,
        });
        const responseData = await response.json();

        if (response.ok) {
          setUploadFile(null);
          fetchResearcher(0);
          Swal.fire({
            icon: "success",
            title: "Upload Successful",
            text: responseData.message || "File uploaded successfully.",
          });
          
          
        } else {
          Swal.fire({
            icon: "warning",
            title: "Upload Failed",
            text: responseData.error || "An error occurred during upload.",
          });
        }
        
      } catch (err) {
        console.error("Upload error:", err);
        Swal.fire({
          icon: "error",
          title: "Upload Error",
          text: "An unexpected error occurred.",
        });
      }
    };
  };

  const parseExcelDetails = (dataString, type) => {
    if (!dataString || typeof dataString !== "string") return [];

    return dataString
      .replace(/^\[|\]$/g, "")
      .split(/\],\s*\[/)
      .map((entry) => {
        const parts = entry.split(" | ").map((part) => {
          const trimmedPart = part.trim();
          return trimmedPart.toLowerCase() === "null" || trimmedPart === ""
            ? ""
            : trimmedPart;
        });

        let parsedEntry = {};

        switch (type) {
          case "jobopenings":
            parsedEntry = {
              jobname: parts[0] || "",
              jobdescription: parts[1] || "",
              jobsource: parts[2] || "",
            };
            break;
          case "newsandsocialinsights":
            parsedEntry = {
              newsname: parts[0] || "",
              newsdescription: parts[1] || "",
              newssource: parts[2] || "",
            };
            break;
          case "financial":
            parsedEntry = {
              financialdescription: parts[0] || "",
              financialsourcelink: parts[1] || "",
              financialyear: parts[2] || "",
            };
            break;
          case "investors":
            parsedEntry = {
              investors: parts[0] || "",
              investorsourcelink: parts[1] || "",
            };
            break;
          default:
            console.warn(`Unknown type: ${type}`);
            parsedEntry = { error: `Invalid type: ${type}` };
            break;
        }

        return parsedEntry;
      });
  };

  const handleCheckMissingFields = async () => {
    if (!uploadFile) {
      console.error("🚨 No file selected");
      Swal.fire({
        icon: "info",
        title: "No File Selected",
        text: "Please select a file before uploading.",
        confirmButtonText: "OK",
        confirmButtonColor: "#FCB124",
      });
      return;
    }

    const token = localStorage.getItem("token");
    if (!token) {
      Swal.fire({
        icon: "error",
        title: "Authentication Error",
        text: "You need to log in again.",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "OK",
      });
      return;
    }

    const formData = new FormData();
    formData.append("file", uploadFile);
    formData.append("selectedFields", JSON.stringify(selectedFields));

    const uploadUrls = [`${baseURL}/api/upload-researcher-excel`];

    try {
      const responses = await Promise.all(
        uploadUrls.map((url) =>
          fetch(url, {
            method: "POST",
            headers: {
              Authorization: `Bearer ${token}`,
            },
            body: formData,
          })
        )
      );

      const results = await Promise.all(responses.map((res) => res.json()));

      const firstWithMissingFields = results.find(
        (result) => result.missingFields && result.missingFields.length > 0
      );

      if (firstWithMissingFields) {
        setMissingFields(firstWithMissingFields.missingFields);
        setShowMissingFieldsPopup(true);
        setShowPopup(false);
      } else {
        handleUpload(true);
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error Checking Missing Fields",
        text: "An error occurred while checking for missing fields. Please try again.",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "OK",
      });
    }
  };

  const handleCheckboxChange = (id) => {
    setSelectedRows((prevSelected) => {
      const isAlreadySelected = prevSelected.includes(id);

      const newSelected = isAlreadySelected
        ? prevSelected.filter((i) => i !== id)
        : [...prevSelected, id];

      setSelectedUserId(
        newSelected.length > 0 ? newSelected[newSelected.length - 1] : null
      );

      return newSelected;
    });
  };

  const handleSelectAll = () => {
    if (selectAll) {
      // Deselect all
      setSelectedRows([]);
    } else {
      // Select all visible/paginated rows
      setSelectedRows(paginatedData.map((user) => user._id));
    }

    setSelectAll(!selectAll); // Toggle the selectAll state
  };

  const handleDownloadExcel = () => {
    if (selectedRows.length === 0) {
      Swal.fire({
        icon: "warning",
        title: "Selection Required!",
        text: "Please select at least one row to download.",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "Ok",
      });
      return;
    }

    const unviewedIds = selectedRows.filter(
      (id) => !viewedProfiles.includes(id)
    );
    if (unviewedIds.length > 0) {
      Swal.fire({
        icon: "warning",
        title: "Access Denied",
        text: "You can only download scoops you’ve already unlocked.",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "Ok",
      });
      setSelectedRows([]);
      setSelectAll();
      return;
    }

    // Define expected headers
    const expectedHeaders = [
      "firstname",
      "companyname",
      "linkedin",
      "email",
      "designation",
      "phonenumber",
      "website",
      "city",
      "state",
      "country",
      "annualrevenue",
      "noofemployees",
      "companylocation",
      "industry",
      "headquarter",
      "subcategory",
      "typeofCustomer",
      "companydescription",
      "followers",
      "technologydetails",
      "jobopenings",
      "newsandsocialinsights",
      "financial",
      "investors",
      "competitors",
      "partner",
      "status"
    ];

    // Filter selected data from paginatedData
    const selectedData = paginatedData.filter((row) =>
      selectedRows.includes(row._id)
    );
    if (selectedData.length === 0) {
      Swal.fire({
        icon: "error",
        title: "No Data",
        text: "No valid data found for download.",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "OK",
      });
      return;
    }

    // Format array fields like jobopenings, etc.
    const formatArrayField = (dataArray, fieldNames) => {
      if (!Array.isArray(dataArray) || dataArray.length === 0) return "";
      return dataArray
        .map(
          (item) =>
            `[${fieldNames.map((field) => item[field] || "").join(" | ")}]`
        )
        .join(", ");
    };

    // Format data according to headers
    const formattedData = selectedData.map((row) =>
      expectedHeaders.reduce((formattedRow, header) => {
        const arrayFieldMappings = {
          jobopenings: ["jobname", "jobdescription", "jobsource"],
          newsandsocialinsights: ["newsname", "newsdescription", "newssource"],
          financial: [
            "financialdescription",
            "financialsourcelink",
            "financialyear",
          ],
          investors: ["investors", "investorsourcelink"],
        };

        if (arrayFieldMappings[header]) {
          formattedRow[header] = formatArrayField(
            row[header],
            arrayFieldMappings[header]
          );
        } else {
          formattedRow[header] = row[header] || "";
        }

        return formattedRow;
      }, {})
    );

    try {
      const worksheet = XLSX.utils.json_to_sheet(formattedData, {
        header: expectedHeaders,
      });
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Selected Data");
      XLSX.writeFile(workbook, "SelectedData.xlsx");
      
      Swal.fire({
        icon: "success",
        title: "Download Successfull",
        text: "File downloaded successfully!",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "OK",
      });
      fetchResearcher();
      setSelectedRows([]);
      setSelectAll();
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Download Failed",
        text: "Failed to download the Excel file. Please try again later.",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "OK",
      });
      setSelectedRows([]);
      setSelectAll();
    }
  };

  const handleDownloadAllData = async () => {
    const allUserIds = data.map((user) => user._id);

    if (role === "user") {
      const missingIds = allUserIds.filter(
        (id) => !viewedProfiles.includes(id)
      );

      if (missingIds.length > 0) {
        Swal.fire({
          icon: "warning",
          title: "Incomplete Access",
          text: "You must unlock all scoops before downloading the full data.",
          confirmButtonColor: "#FCB124",
          confirmButtonText: "Ok",
        });
        return;
      }
    }

    try {
      const token = localStorage.getItem("token");

      const response = await fetch(`${baseURL}/api/download-researcher-excel`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error("Failed to download file");
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = "Contacts.xlsx";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      Swal.fire({
        icon: "success",
        title: "Download Complete!",
        text: "Your file has been downloaded successfully.",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "Ok",
      });
      setSelectedRows([]);
      setSelectAll();
    
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error Downloading File",
        text: "There was a problem downloading the file. Please try again.",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "OK",
      });
    }
  };

  const handleDisplayContacts = () => {
    setSearchData("");
    setIsMyContacts(false);
    setIsContacts(true);
    setuserlists(false);
    setSelectedRows([]);
    setSelectAll();
  };

  const handleDisplayUserLists = () => {
    setuserlists(true);
    setIsContacts(false);
    setIsMyContacts(false);
    setSearchData("");
    setSelectedRows([]);
    setSelectAll();
  };

  const handleSingleRequest = () => {
    setIsSingleRequests(true);
    setIsBulkRequests(false);
    setIsContacts(false);
    setIsDataRequest(false);
    setIsEditRequest(false);
  };

  const handleDisplayBulkRequestData = () => {
    setIsSingleRequests(false);
    setIsBulkRequests(true);
    setIsContacts(false);
    setIsDataRequest(false);
    setIsEditRequest(false);
    setIsEditRequest(false);
  };

  const handleDisplayResearchRequestData = () => {
    setIsSingleRequests(false);
    setIsBulkRequests(false);
    setIsContacts(false);
    setIsResearchRequests(true);
    setIsDataRequest(false);
    setIsEditRequest(false);
  };

  const handleDisplayDataRequestData = () => {
    setIsSingleRequests(false);
    setIsBulkRequests(false);
    setIsContacts(false);
    setIsResearchRequests(false);
    setIsDataRequest(true);
    setIsEditRequest(false);
  };

  const handleDisplayEditRequestData = () => {
    setIsSingleRequests(false);
    setIsBulkRequests(false);
    setIsContacts(false);
    setIsResearchRequests(false);
    setIsDataRequest(false);
    setIsEditRequest(true);
  };

  const handleDisplayHistoryData = () => {
    navigate("/user-management");
  };

const handlePushToList = async (e) => {
  e.preventDefault();

  if (selectedRows.length === 0) {
    Swal.fire({
      icon: "warning",
      title: "No Selection",
      text: "Please select at least one entry to push.",
      confirmButtonColor: "#FCB124",
      confirmButtonText: "OK",
    });
    return;
  }

  const token = localStorage.getItem("token");
  if (!token) {
    Swal.fire({
      icon: "error",
      title: "Error",
      text: "You need to login first",
    });
    return;
  }

 const payload = {
  researcherId: researcherId,    
  selectedUserIds: selectedRows, 
};

  try {
    const response = await fetch(`${baseURL}/api/pushtolist`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payload),
    });

    const data = await response.json();

    if (response.ok) {
      Swal.fire({
        icon: "success",
        title: "Success",
        text: "Contact(s) pushed successfully",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "OK",
      });
      setSelectedRows([]);
      setSelectAll();
    } else {
      Swal.fire({
        icon: "warning",
        title: "Some contacts already exist",
        text: data.message,
        confirmButtonColor: "#FCB124",
        confirmButtonText: "OK",
      });
      setSelectedRows([]);
      setSelectAll();
    }
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "...oops",
      text: "Something went wrong",
      confirmButtonColor: "#FCB124",
      confirmButtonText: "OK",
    });
    setSelectedRows([]);
    setSelectAll();
  }
};

  const handleSubmitEditRequest = async (requestItem) => {
    const token = localStorage.getItem("token");

    try {
      const response = await axios.post(`${baseURL}/api/admin`, requestItem, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      Swal.fire({
        icon: "success",
        title: "Approved",
        text: "Request approved and posted successfully!",
        confirmButtonColor: "#FCB124",
      });
      setEditRequest((prevRequests) =>
        prevRequests.map((req) =>
          req._id === requestItem._id ? { ...req, status: "Approved" } : req
        )
      );
    } catch (error) {
      console.error("Error approving request:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to post request",
      });
    }
  };

  const handleRejectEditRequest = async (userEmail) => {
    const token = localStorage.getItem("token");

    try {
      await axios.put(
        `${baseURL}/api/admin/reject-request`,
        { adminId, userEmail },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      Swal.fire({
        icon: "success",
        title: "Rejected",
        text: "Edit request rejected successfully",
      });

      // Refresh list
    } catch (error) {
      console.error("Error rejecting request:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Could not reject the request",
      });
    }
  };

  // Update form data when admin fills input
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmitDetails = async (e) => {
    e.preventDefault();

    const token = localStorage.getItem("token");

    if (!token) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "You need to login first",
      });
      return;
    }

    if (!selectedRequest || !selectedRequest._id) {
      Swal.fire({
        icon: "info",
        title: "No Selection",
        text: "No request selected!",
        confirmButtonText: "OK",
        confirmButtonColor: "#FCB124",
      });
      return;
    }

    const uploadUrls = [
      `${baseURL}/api/update-single-request-research/${selectedRequest._id}`,
    ];

    try {
      const responses = await Promise.all(
        uploadUrls.map((url) =>
          fetch(url, {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
              requestedFields: formData,
              status: "Submitted",
            }),
          })
        )
      );

      const results = await Promise.all(responses.map((res) => res.json()));

      const allSuccessful = responses.every((res) => res.ok);

      if (allSuccessful) {
        Swal.fire({
          icon: "success",
          title: "Request updated successfully!",
          confirmButtonColor: "#FCB124",
          confirmButtonText: "Ok",
        });

        const updated = results.find((res) => res.updatedRequest); 
        if (updated) {
          setFormData(updated.updatedRequest);
        }
        fetchResearcher();
        setShowForm(false);
      } else {
        const firstError = results.find((res) => res.error);
        Swal.fire({
          icon: "info",
          title: "Update Failed",
          text:
            "Failed to update request: " +
            (firstError?.error || "Unknown error"),
          confirmButtonText: "OK",
          confirmButtonColor: "#FCB124",
        });
      }
    } catch (error) {
      console.error("Error updating request:", error);
      Swal.fire({
        icon: "info",
        title: "Update Error",
        text: "Error updating request",
        confirmButtonText: "OK",
        confirmButtonColor: "#FCB124",
      });
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setResearch((prevDetails) => ({
      ...prevDetails,
      [name]: value,
    }));
  };

  const handleFieldValueChange = (e, index) => {
    const { value } = e.target;
    setResearch((prevResearch) => {
      const updatedExtraFields = prevResearch.extraFields
        ? [...prevResearch.extraFields]
        : [];

      if (updatedExtraFields[index]) {
        updatedExtraFields[index].value = value;
      }

      return {
        ...prevResearch,
        extraFields: updatedExtraFields,
      };
    });
  };

  const handleSendResearch = async (e) => {
    e.preventDefault();

    const token = localStorage.getItem("token");
    const userId = localStorage.getItem("userId");
    const userName = localStorage.getItem("name");
    const userEmail = localStorage.getItem("email");

    if (!token) {
      Swal.fire({
        icon: "warning",
        title: "Access Denied",
        text: "You must log in first!",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "OK",
      });
      return;
    }

    const requestData = {
      ...research,
      adminId,
      userId,
      userName,
      userEmail,
      matchId: research?._id || null,
    };

    try {
      let response;
      if (isMyContacts) {
        response = await fetch(`${baseURL}/api/research-data`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(requestData),
        });
      } else if (userlists) {
        response = await fetch(`${baseURL}/api/research-data/:listName`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(requestData),
        });
      }

      const responseData = await response.json();

      if (response.ok) {
        setResearch(responseData);
        setIsResearch(false);
        setSelectedRows([]);
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "Research data sent successfully.",
          confirmButtonColor: "#FCB124",
          confirmButtonText: "OK",
        });
        if (remainingCredits > 0) {
          const updatedSpent = spentCredits + 1;
          const updatedRemaining = remainingCredits - 1;

          setSpentCredits(updatedSpent);
          setRemainingCredits(updatedRemaining);

          saveCreditsToDB(credits, updatedSpent, updatedRemaining);
        } else {
          Swal.fire({
            icon: "warning",
            title: "No Remaining Credits",
            confirmButtonColor: "#FCB124",
            confirmButtonText: "OK",
          });
        }
      } else {
        throw new Error(
          responseData.message || "Failed to send research data."
        );
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.message || "Something went wrong. Please try again.",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "OK",
      });
      console.error("Request failed:", error);
    }
  };

  const handleViewResearch = (item) => {
    setResearch(item || {});
    setIsResearch(true);
  };

  const handleSubmitResearch = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("token");

    if (!token) {
      Swal.fire({
        icon: "error",
        title: "You must log in first.",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "Ok",
      });
      return;
    }

    try {
      const response = await axios.put(
        `${baseURL}/api/submit-research`,
        {
          userId: research.userId,
          matchId: research.matchId,
          extraFields: extraFields,
          status: "Submitted",
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200) {
        setResearch(response.data.data);
        Swal.fire({
          icon: "success",
          title: "Extra field updated successfully!",
          confirmButtonColor: "#FCB124",
          confirmButtonText: "Ok",
        });
        fetchResearcher();
        setIsResearch(false);
      } else {
        Swal.fire({
          icon: "error",
          title: "Error occurred while submitting details.",
          confirmButtonColor: "#FCB124",
          confirmButtonText: "Ok",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: error.response?.data?.message || "An error occurred.",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "Ok",
      });
    }
  };

  const handleApproveResearch = async (userId, matchId) => {
    try {
      const response = await fetch(
        `${baseURL}/api/approve-research-request/${userId}/${matchId}`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ matchId, status: "Approved" }),
        }
      );
      const data = await response.json();

      if (response.ok) {
        Swal.fire({
          icon: "success",
          title: "Request Approved Successfully!",
          text: "Request Approved Successfully!",
          confirmButtonColor: "#FCB124",
          confirmButtonText: "Ok",
        });
        setRequests((prevRequests) =>
          prevRequests.map((req) =>
            req.userId === userId && req.matchId === matchId
              ? { ...req, status: "Approved" }
              : req
          )
        );
        fetchResearcher();
        setIsResearch(false);
      } else {
        Swal.fire({
          icon: "error",
          title: data.message || "Failed to approve the request.",
          confirmButtonColor: "#FCB124",
          confirmButtonText: "Okay",
        });
      }
    } catch (error) {
      console.error("Approval Error:", error);
      Swal.fire({
        icon: "error",
        title: "Something went wrong.",
        text: "Please try again.",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "Ok",
      });
    }
  };

  const handleDownloadDataRequest = async (adminId, fileName) => {
    try {
      const response = await fetch(
        `${baseURL}/api/download-excel/${adminId}/${fileName}`
      );

      if (!response.ok) {
        throw new Error("Failed to download file");
      }

      const data = await response.json();

      if (!data.fileBase64) {
        Swal.fire({
          icon: "info",
          title: "File Not Found",
          text: "File not found!",
          confirmButtonText: "OK",
          confirmButtonColor: "#FCB124",
        });
        return;
      }

      // Convert Base64 to Blob
      const byteCharacters = atob(data.fileBase64);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      // Create download link
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = data.fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Download error:", error);
      Swal.fire({
        icon: "info",
        title: "Download Failed",
        text: "Failed to download file.",
        confirmButtonText: "OK",
        confirmButtonColor: "#FCB124",
      });
    }
  };

  const handleVerifyRequest = async (requestId) => {
    try {
      const token = localStorage.getItem("token");
      const response = await fetch(
        `${baseURL}/api/verify-request/${requestId}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const data = await response.json();
      if (data.message === "Request successfully verified!") {
        Swal.fire({
          icon: "success",
          title: "success!",
          text: "Request Verified",
          confirmButtonColor: "#FCB124",
          confirmButtonText: "Ok",
        });
        fetchResearcher();
      } else {
        Swal.fire({
          icon: "info",
          title: "Notice",
          text: data.message,
          confirmButtonText: "OK",
          confirmButtonColor: "#FCB124",
        });
      }
    } catch (error) {
      console.error("Error verifying request:", error);
      Swal.fire({
        icon: "error",
        title: "Verification Failed",
        text: "Failed to verify request.",
        confirmButtonText: "Ok",
      });
    }
  };

  const handleApproveDataRequest = (item) => {
    if (!item.fileBase64) {
      Swal.fire({
        icon: "warning",
        title: "No file found!",
        text: "Please make sure a file is attached before approving.",
        confirmButtonColor: "#FCB124",
      });
      return;
    }

    // Convert Base64 to Blob
    const byteCharacters = atob(item.fileBase64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const fileBlob = new Blob([byteArray], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    fileBlob.name = item.fileName;

    setUploadFile(fileBlob);

    // Proceed with upload
    handleUpload();
  };

  const handleLabelSubmit = async (e) => {
    if (e.key === "Enter" && newFieldLabel.trim()) {
      const updatedFields = research.extraFields?.length
        ? [...research.extraFields, { label: newFieldLabel, value: "" }]
        : [{ label: newFieldLabel, value: "" }];

      setResearch((prev) => ({
        ...prev,
        extraFields: updatedFields,
      }));

      setNewFieldLabel("");
      setShowLabelInput(false);

      // ✅ Save to backend with userid
      try {
        const token = localStorage.getItem("token");
        if (isMyContacts) {
          await axios.put(
            `${baseURL}/api/update-research/${research._id}`,
            { extraFields: updatedFields },
            {
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
            }
          );
        } else if (userlists) {
          await axios.put(
            `${baseURL}/api/update-research/${listName}/${research._id}`,
            { extraFields: updatedFields },
            {
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
            }
          );
        }
      } catch (error) {
        console.error("Error updating extra fields:", error);
        Swal.fire({
          icon: "info",
          title: "Save Failed",
          text: "Failed to save extra fields.",
          confirmButtonText: "OK",
          confirmButtonColor: "#FCB124",
        });
      }
    }
  };

  const handleDownloadBulkFile = async () => {
    try {
      const response = await fetch(
        `${baseURL}/api/download-bulk-requests/${researcherId}`
      );

      if (!response.ok) {
        throw new Error("Failed to download file");
      }

      const blob = await response.blob();
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "Bulk_Requests.xlsx";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Download error:", error);
    }
  };

  const handleBulkFileChange = (e) => {
    setFile(e.target.files[0]);
  };


  const handleUploadFile = async () => {
  if (!file) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Please select a file first!",
    });
    return;
  }

  const reader = new FileReader();
  reader.readAsArrayBuffer(file);

  reader.onload = async (e) => {
    try {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });

      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];

      if (!sheet) {
        Swal.fire({
          icon: "error",
          title: "Invalid Excel File",
          text: "No valid sheet found in the Excel file.",
        });
        return;
      }

      let jsonData = XLSX.utils.sheet_to_json(sheet, { defval: "" });

     const parseJobOpenings = (inputString) => {
  if (!inputString || typeof inputString !== "string") return [];

  return inputString.split("], [").map((item) => {
    const values = item.replace(/\[|\]/g, "").split(" | ").map(v => v.trim());
    return {
      jobname: values[0] || "",
      jobdescription: values[1] || "",
      jobsource: values[2] || ""
    };
  });
};
const parseNews = (inputString) => {
  if (!inputString || typeof inputString !== "string") return [];

  return inputString.split("], [").map((item) => {
    const values = item.replace(/\[|\]/g, "").split(" | ").map(v => v.trim());
    return {
      newsname: values[0] || "",
      newsdescription: values[1] || "",
      newssource: values[2] || ""
    };
  });
};


      const formattedData = jsonData
        .map((row) => {
          const normalizedRow = {};
          Object.keys(row).forEach((key) => {
            normalizedRow[key.trim().toLowerCase()] = row[key];
          });

          return {
            _id: normalizedRow["_id"] || "",
            technologydetails: normalizedRow["technology details"] || "",
            jobopenings: parseJobOpenings(normalizedRow["job openings"]),
            newsandsocialinsights: parseNews(normalizedRow["news and social insights"]),
          };
        })
        .filter((item) => item._id); 

      const token = localStorage.getItem("token");
      if (!token) {
        Swal.fire({
          icon: "warning",
          title: "Authentication Required",
          text: "No token found! Please log in again.",
          confirmButtonColor: "#FCB124",
          confirmButtonText: "OK",
        });
        return;
      }

      const response = await axios.put(
        `${baseURL}/api/upload-bulk-request-excel`,
        {
          data: formattedData,
          researcherId,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      fetchResearcher();

      Swal.fire({
        icon: "success",
        title: "Upload Complete",
        html: `${response.data.data.length} requests updated successfully.`,
        confirmButtonColor: "#FCB124",
      });
    } catch (error) {
      console.error("Upload error:", error);
      Swal.fire({
        icon: "error",
        title: "Upload Failed",
        text: "An error occurred while processing the file.",
      });
    }
  };
};

  const handleApproveRequest = async (userId, matchId) => {
    try {
      const response = await fetch(
        `${baseURL}/api/approve-single-request/${userId}/${matchId}`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
        }
      );

      const data = await response.json();

      if (response.ok) {
        Swal.fire({
          icon: "success",
          title: "Request Approved Successfully!",
          text: "The request has been approved.",
          confirmButtonColor: "#FCB124",
          confirmButtonText: "OK",
        });

        fetchResearcher();
        setSelectedRows([]);
      } else {
        Swal.fire({
          icon: "error",
          title: "Approval Failed",
          text: data.message || "Failed to approve the request.",
          confirmButtonColor: "#FCB124",
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      console.error("Approval Error:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong. Please try again.",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "OK",
      });
    }
  };

  const handleRejectRequest = async (userId, matchId) => {
    const confirmReject = await Swal.fire({
      icon: "warning",
      title: "Are you sure?",
      text: "Do you really want to reject this request?",
      showCancelButton: true,
      confirmButtonColor: "#FCB124",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, Reject",
      cancelButtonText: "Cancel",
    });

    if (!confirmReject.isConfirmed) return;
    try {
      const response = await fetch(
        `${baseURL}/api/reject-single-request/${userId}/${matchId}`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
        }
      );

      const data = await response.json();

      if (response.ok) {
        Swal.fire({
          icon: "success",
          title: "Request Rejected",
          text: data.message,
          confirmButtonColor: "#FCB124",
          confirmButtonText: "OK",
        });

        fetchResearcher();
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: data.message || "Failed to reject request.",
          confirmButtonColor: "#FCB124",
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      console.error("Error rejecting request:", error);
      Swal.fire({
        icon: "error",
        title: "Server Error",
        text: "Something went wrong. Please try again later.",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "OK",
      });
    }
  };

  const handleApproveBulkRequest = async (id) => {
    try {
      const response = await fetch(
        `${baseURL}/api/approve-bulk-request/${id}`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
        }
      );
      const data = await response.json();

      if (response.ok) {
        Swal.fire({
          icon: "success",
          title: "Request Approved Successfully!",
          confirmButtonColor: "#FCB124",
          confirmButtonText: "OK",
        });
        fetchResearcher();
      } else {
        Swal.fire({
          icon: "error",
          title: data.message,
          confirmButtonColor: "#FCB124",
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      console.error("Approval Error:", error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong. Please try again.",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "OK",
      });
    }
  };

  const handleRejectBulkRequest = async (requestId) => {
    try {
      const confirmation = await Swal.fire({
        title: "Are you sure?",
        text: "You are about to reject this bulk request.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, Reject it!",
        cancelButtonText: "Cancel",
      });

      if (!confirmation.isConfirmed) return;

      // Send API request
      const response = await axios.put(
        `${baseURL}/api/reject-bulk-request/${requestId}`
      );

      // Update UI
      setBulkRequests((prevRequests) =>
        prevRequests.map((req) =>
          req._id === requestId ? { ...req, status: "Rejected" } : req
        )
      );

      Swal.fire({
        icon: "success",
        title: "Rejected!",
        text: "Bulk request has been rejected successfully.",
      });
    } catch (error) {
      console.error("Error rejecting request:", error);
      Swal.fire({
        icon: "error",
        title: "Oops!",
        text: "Failed to reject bulk request.",
      });
    }
  };

  const handleViewRequest = (item) => {
    const itemToEditForm = singleRequests.find(
      (request) => request._id === item._id
    );

    if (itemToEditForm) {
      setFormData({ ...itemToEditForm });
    } else {
      console.error("Item not found in singleRequests");
    }

    setSelectedRequest(item);
    setShowForm(true);
  };

  const handleViewEditRequest = (item) => {
    const itemToOpen = editRequest.find((request) => request._id === item._id);

    if (itemToOpen) {
      setFormData({ ...itemToOpen });
    } else {
      console.error("Item not found in singleRequests");
    }

    setSelectedRequest(item);
    setShowForm(true);
  };

  const getStatusClass = (status) => {
    switch (status.toLowerCase()) {
      case "pending":
        return "status-pending";
      case "submitted":
        return "status-submitted";
      case "approved":
        return "status-approved";
      case "rejected":
        return "status-rejected";
      default:
        return;
    }
  };

  const getBulkStatusClass = (status) => {
    switch (status.toLowerCase()) {
      case "pending":
        return "status-pending";
      case "submitted":
        return "status-submitted";
      case "approved":
        return "status-approved";
      case "rejected":
        return "status-rejected";
      default:
        return;
    }
  };

  const getResearchStatusClass = (status) => {
    if (!status) return "";

    switch (status.toLowerCase()) {
      case "pending":
        return "status-pending";
      case "submitted":
        return "status-submitted";
      case "approved":
        return "status-approved";
      case "rejected":
        return "status-rejected";
      default:
        return;
    }
  };

  const getDataStatusClass = (status) => {
    if (!status) return "";

    switch (status.toLowerCase()) {
      case "pending":
        return "status-pending";
      case "submitted":
        return "status-submitted";
      case "approved":
        return "status-approved";
      case "rejected":
        return "status-rejected";
      default:
        return;
    }
  };

  const getEditStatusClass = (status) => {
    if (!status) return "";

    switch (status.toLowerCase()) {
      case "pending":
        return "status-pending";
      case "approved":
        return "status-approved";
      case "rejected":
        return "status-rejected";
      default:
        return "status-default";
    }
  };

  const handleVerifyData = async () => {
    if (selectedRows.length === 0) {
      Swal.fire({
        icon: "info",
        title: "No Contact Selected",
        text: "Please select at least one contact.",
        confirmButtonText: "OK",
        confirmButtonColor: "#FCB124",
      });
      return;
    }

    try {
      const token = localStorage.getItem("token");

      const response = await axios.put(
        `${baseURL}/api/verify-contacts`,
        {
          contactIds: selectedRows,
          status: "Verified",
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {
        Swal.fire({
          icon: "success",
          title: "Verified!",
        });
        fetchResearcher(currentChunkIndex);
        setSelectedRows([]);
        setSelectAll(false);
      }
    } catch (error) {
      console.error("Error updating status:", error);
      Swal.fire({
        icon: "info",
        title: "Update Failed",
        text: "Failed to update status.",
        confirmButtonText: "OK",
        confirmButtonColor: "#FCB124",
      });
    }
  };

  // const handleApproveData = async () => {
  //   if (selectedRows.length === 0) {
  //     Swal.fire({
  //       icon: "info",
  //       title: "No Contact Selected",
  //       text: "Please select at least one contact.",
  //       confirmButtonText: "OK",
  //       confirmButtonColor: "#FCB124",
  //     });
  //     return;
  //   }

  //   try {
  //     const token = localStorage.getItem("token");

  //     const response = await axios.put(
  //       `${baseURL}/api/approve-contacts`,
  //       {
  //         researcherId: researcherId,
  //         contactIds: selectedRows,
  //         status: "Approved",
  //       },
  //       {
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //           "Content-Type": "application/json",
  //         },
  //       }
  //     );

  //     if (response.status === 200) {
  //       Swal.fire({
  //         icon: "success",
  //         title: "Approved!",
  //       });
  //       fetchResearcher();
  //               setSelectedRows([]);

  //     }
  //   } catch (error) {
  //     console.error("Error updating status:", error);
  //     Swal.fire({
  //       icon: "info",
  //       title: "Update Incomplete",
  //       text: "Could not update the status. Please try again.",
  //     });
  //   }
  // };

  const getImageData = (status) => {
  switch (status) {
    case "Not Verified":
      return { src: Not_Verified, alt: "Not Verified", tooltip: "Not Verified" };
    case "Verified":
      return { src: Verified, alt: "Verified", tooltip: "Verified" };
    case "Expiring":
      return { src: Expiring, alt: "Expiring", tooltip: "Expiring Soon" };
    default:
      return { src: Not_Verified, alt: "Not Verified", tooltip: "Not Verified" };
  }
};
  
  return (
    <>
      <div>
        <Header
          setSearchData={setSearchData}
          credits={credits}
          setCredits={setCredits}
          spentCredits={spentCredits}
          setSpentCredits={setSpentCredits}
          remainingCredits={remainingCredits}
          setRemainingCredits={setRemainingCredits}
          saveCreditsToDB={saveCreditsToDB}
          isContacts={isContacts}
          setIsContacts={setIsContacts}
          userlists={userlists}
        />
      </div>
      <div className="companies-container">
        <SidebarFilter
          selectedListName={selectedListName}
          setSelectedListName={setSelectedListName}
          selectedFilters={selectedFilters}
          setSelectedFilters={setSelectedFilters}
          setFilteredData={setFilteredData} 
          handleDisplayUserLists={handleDisplayUserLists}
          totalCount={totalCount}
          setTotalCount={setTotalCount}
          userlists={userlists}
          setuserlists={setuserlists}
          setIsContacts={setIsContacts}
          handleDisplayContacts={handleDisplayContacts}
          isContacts={isContacts}
          currentPage={currentPage}
          itemsPerPage={itemsPerPage}
        />
        <div className="companies">
          <div className="companies-top">
            <div className={`people-favorite`}>
              {(role === "admin" || role === "researcher") &&
              role !== "user" ? (
                <div className="request-container">
                  <div className="all-request-container">
                    <div
                      className={`people-flex ${
                        activeContainer === "singleRequest" ? "active" : ""
                      }`}
                      onClick={() => {
                        handleSingleRequest();
                        handleSetActive("singleRequest");
                      }}
                    >
                      <div className="people-dwld">
                        <p>Single Requests</p>
                        <span>{singleRequests.length}</span>
                      </div>
                    </div>
                    <div
                      className={`people-flex ${
                        activeContainer === "bulkRequests" ? "active" : ""
                      }`}
                      onClick={() => {
                        handleDisplayBulkRequestData();
                        handleSetActive("bulkRequests");
                      }}
                    >
                      <div className="people-dwld">
                        <p>Bulk Requests</p>
                        <span>{bulkRequests.length}</span>
                      </div>
                    </div>
                    <div
                      className={`people-flex ${
                        activeContainer === "researchRequests" ? "active" : ""
                      }`}
                      onClick={() => {
                        handleDisplayResearchRequestData();
                        handleSetActive("researchRequests");
                      }}
                    >
                      <div className="people-dwld">
                        <p>Research Requests</p>
                        <span>{researchRequest.length}</span>
                      </div>
                    </div>
                    <div
                      className={`people-flex ${
                        activeContainer === "dataRequests" ? "active" : ""
                      }`}
                      onClick={() => {
                        handleDisplayDataRequestData();
                        handleSetActive("dataRequests");
                      }}
                    >
                      <div className="people-dwld">
                        <p>Data Requests</p>
                        <span>{dataRequest.length}</span>
                      </div>
                    </div>
                    <div
                      className={`people-flex ${
                        activeContainer === "editRequests" ? "active" : ""
                      }`}
                      onClick={() => {
                        handleDisplayEditRequestData();
                        handleSetActive("editRequests");
                      }}
                    >
                      <div className="people-dwld">
                        <p>Edit Requests</p>
                        <span>{editRequest.length}</span>
                      </div>
                    </div>
                    <div
                      className={`people-flex ${
                        activeContainer === "history" ? "active" : ""
                      }`}
                      onClick={() => {
                        handleDisplayHistoryData();
                        handleSetActive("history");
                      }}
                    >
                      <div className="people-dwld">
                        <p>History</p>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <></>
              )}
            </div>
          </div>
          <div className="companies-count">
            <div className="count">
              {isContacts && (
                <div className="crm-contacts">
                  <div className="crm-add-search">
                    <p>
                      Contacts &nbsp;
                      <span style={{ fontSize: "24px" }}>{totalCount}</span>
                    </p>
                    {role === "user" && (
                      <div>
                        <button
                          className="create-list-btn"
                          style={{ width: "170px" }}
                          onClick={handlePushToList}
                        >
                          Push to my contacts
                        </button>
                      </div>
                    )}
                    {(role === "admin" || role === "researcher") && (
                      <div>
                        <button onClick={handleDownloadAllData}>
                          <IoMdDownload />
                        </button>
                      </div>
                    )}
                    <div></div>
                  </div>
                  <div className="crm-add-search">
                    {role === "researcher" && (
                      <div>
                        <div className="company-btn">
                          <button
                            style={{
                              width: "100px",
                              height: "30px",
                              borderRadius: "5px",
                              color: "#FCB124",
                            }}
                            onClick={() => handleUpload()}
                          >
                            Bulk Upload
                          </button>
                          <input
                            className="input-upload"
                            type="file"
                            accept=".xlsx, .xls"
                            onChange={handleFileChange}
                          />
                        </div>
                        {uploadFile && (
                          <div className="upload-status">
                            <span style={{ fontSize: "12px" }}>✅</span>
                            <span style={{ fontSize: "12px" }}>
                              Ready to Upload!
                            </span>
                          </div>
                        )}
                      </div>
                    )}
                    {role === "researcher" && (
                      <div onClick={handleVerifyData}>
                        <button
                          style={{
                            width: "80px",
                            height: "30px",
                            backgroundColor: "#FCB124",
                            borderRadius: "5px",
                            color: "#fff",
                            fontWeight: "bold",
                            fontSize: "14px",
                          }}
                        >
                          Verify
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
            {(isLoading ) ? (
              <div className="spinner-container">
                <div className="loading-spinner"></div>
                <p style={{ marginTop: "10px", color: "#666" }}>Loading...</p>
              </div>
            ) : isContacts  ? (
              paginatedData.length === 0 ? (
                <div
                  style={{
                    textAlign: "center",
                    fontSize: "18px",
                    color: "#aaa",
                    marginTop: "100px",
                  }}
                >
                  <p>No data found</p>
                </div>
              ) : (
                <>
                  <div className="table-icons">
                    <div className="tablepagination">
                      <table className="company-table">
                        <thead>
                          <tr>
                            <th>
                              <input
                                type="checkbox"
                                checked={selectAll}
                                onChange={handleSelectAll}
                              />
                            </th>
                            {visibleColumns.firstname && <th>Name</th>}
                            {visibleColumns.companyname && (
                              <th>Company Name</th>
                            )}
                            {visibleColumns.email && <th>Email</th>}
                            {visibleColumns.designation && <th>Designation</th>}
                            <th>Scoop</th>
                            <th>Status</th>
                            <th>Last updated</th>
                          </tr>
                        </thead>
                        <tbody>
                          {paginatedData.map((user) => {
                            const { src, alt, tooltip } = getImageData(user.status);
                            return(
                            <tr key={user._id}>
                              <td>
                                <input
                                  type="checkbox"
                                  value={user._id}
                                  checked={selectedRows.includes(user._id)}
                                  onChange={() =>
                                    handleCheckboxChange(user._id)
                                  }
                                />
                              </td>
                              {visibleColumns.firstname && (
                                <td className="name-linkedin">
                                  <span>
                                    <p>{user.firstname}</p>
                                  </span>
                                  {visibleColumns.linkedin && user.linkedin && (
                                    <FaLinkedin
                                      className="linkedin"
                                      style={{ margin: "0px 10px" }}
                                    />
                                  )}
                                </td>
                              )}
                             {visibleColumns.companyname && (
  <td>
    {user.companyname
      ? user.companyname.length > 20
        ? `${user.companyname.slice(0, 20)}...`
        : user.companyname
      : "N/A"}
  </td>
)}

{visibleColumns.email && (
  <td
    style={{
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "left",
    }}
  >
    <MdOutlineMailOutline
      style={{
        margin: "0px 5px",
        alignItems: "center",
        color: "#0000FF",
      }}
    />
    {user.email
      ? user.email.length > 20
        ? `${user.email.slice(0, 20)}...`
        : user.email
      : "N/A"}
  </td>
)}

{visibleColumns.designation && (
  <td>
    {user.designation
      ? user.designation.length > 20
        ? `${user.designation.slice(0, 20)}...`
        : user.designation
      : "N/A"}
  </td>
)}

                              <td
                                style={{ cursor: "default" }}
                                className="expand"
                              >
                                {!user.technologydetails &&
                                user.jobopenings &&
                                user.newsandsocialinsights ? (
                                  <span>
                                    <button style={{ cursor: "default" }}>
                                      <GiCampfire
                                        style={{
                                          color: "#ccc",
                                          fontSize: "24px",
                                        }}
                                      />
                                    </button>
                                  </span>
                                ) : (
                                  <span
                                    className="scoop-fire-1"
                                    style={{ margin: "0px 5px" }}
                                  >
                                    <GiCampfire />
                                  </span>
                                )}
                              </td>
                              <td>
                                {user.status === "Not Verified" ? (
                                  <img
                                    src={src}
                                    alt={alt}
                                     title={tooltip} 
                                    className="verified-not-expire"
                                  />
                                ) : user.status === "Verified" ? (
                                  <img
                                    src={src}
                                    alt={alt}
                                    title={tooltip} 
                                    className="verified-not-expire"
                                  />
                                ) : user.status === "Expiring" ? (
                                  <img
                                    src={src}
                                    alt={alt}
                                    title={tooltip} 
                                    className="verified-not-expire"
                                  />
                                ) : (
                                  <img
                                    src={src}
                                    alt={alt}
                                    title={tooltip} 
                                    className="verified-not-expire"
                                  />
                                )}
                              </td>
                              <td className="expand">
                                <span
                                  className="scoop-fire"
                                  style={{ margin: "0px 5px" }}
                                >
                                  <button>
                                    {user.updatedAt
                                      ? new Date(
                                          user.updatedAt
                                        ).toLocaleDateString('en-GB').replace(/\//g, '-')
                                      : "N/A"}
                                  </button>
                                </span>
                              </td>
                            </tr>
                            )})}
                        </tbody>
                      </table>
                      <div className="table-pagination">
                        <div>
                          <button
                            className="nav-button"
                            onClick={() => goToPage(currentPage - 1)}
                            disabled={currentPage === 1}
                          >
                            Prev
                          </button>
                        </div>

                        {(() => {
                          const pageButtons = [];
                          const maxVisible = 5;
                          let startPage = Math.max(1, currentPage - 2);
                          let endPage = Math.min(
                            totalPages,
                            startPage + maxVisible - 1
                          );

                          if (endPage - startPage < maxVisible - 1) {
                            startPage = Math.max(1, endPage - maxVisible + 1);
                          }

                          for (let i = startPage; i <= endPage; i++) {
                            pageButtons.push(
                              <button
                                key={i}
                                className={
                                  currentPage === i ? "active-page" : ""
                                }
                                onClick={() => goToPage(i)}
                                style={{
                                  fontWeight:
                                    currentPage === i ? "bold" : "normal",
                                  margin: "5px",
                                }}
                              >
                                {i}
                              </button>
                            );
                          }

                          return pageButtons;
                        })()}

                        <button
                          className="nav-button"
                          onClick={() => goToPage(currentPage + 1)}
                          disabled={currentPage === totalPages}
                        >
                          Next
                        </button>
                      </div>
                      {/* <div className="table-pagination">
                          <div>
                            <button
                              className="nav-button"
                              onClick={() => goToPage(currentPage - 1)}
                              disabled={currentPage === 1}
                            >
                              Prev
                            </button>
                          </div>

                          {(() => {
                            const pageButtons = [];
                            const maxVisible = 5;
                            let startPage = Math.max(1, currentPage - 2);
                            let endPage = Math.min(totalPages, startPage + maxVisible - 1);

                            if (endPage - startPage < maxVisible - 1) {
                              startPage = Math.max(1, endPage - maxVisible + 1);
                            }

                            for (let i = startPage; i <= endPage; i++) {
                              console.log(i)
                              pageButtons.push(
                                <button
                                  key={i}
                                  className={currentPage === i ? "active-page" : ""}
                                  onClick={() => goToPage(i)}
                                  style={{
                                    fontWeight: currentPage === i ? "bold" : "normal",
                                    margin: "5px",
                                  }}
                                >
                                  {i}
                                </button>
                              );
                            }

                            return pageButtons;
                          })()}

                          <button
                            className="nav-button"
                            onClick={() =>{
                              console.log(currentPage);
                             goToPage(currentPage + 1)}}
                            disabled={currentPage === totalPages}
                          >
                            Next
                          </button>
                        </div> */}
                    </div>
                    {role === "researcher" && (
                      <div className="crm-icons">
                        <div className="crm-search">
                          <button
                            className="crm-download"
                            onClick={handleDownloadExcel}
                          >
                            <IoMdDownload />
                          </button>
                        </div>
                        <div
                          className="crm-search"
                          onClick={() => {
                            handleEdit(selectedUserId);
                          }}
                        >
                          {((role === "admin" &&
                            (!isSingleRequests || !isBulkRequests)) ||
                            role === "researcher") && (
                            <button className="crm-edit">
                              <CiEdit />
                            </button>
                          )}
                        </div>
                        <div className="crm-search">
                          {((role === "admin" &&
                            (!isSingleRequests || !isBulkRequests)) ||
                            (role === "researcher" && isContacts)) && (
                            <button
                              className="crm-delete"
                              onClick={handleDelete}
                            >
                              <MdDelete />
                            </button>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                </>
              )
            ) : (role === "researcher" || role === "admin") &&
              isSingleRequests &&
              !isContacts ? (
              <div>
                <div>
                  {singleRequests.map((item, index) => (
                    <div className="request-item" key={index}>
                      <div>
                        <p className="msg-request">
                          You have received a new request from{" "}
                          <span style={{ fontWeight: "bold", color: "#000" }}>
                            {item.userName}
                          </span>{" "}
                          <span>({item.userEmail})</span>
                        </p>
                        <p className="review-request">
                          Please review the requested details, including
                          Technology Details, Job Openings, and News & Insights.
                        </p>
                        <p className="date-request">
                          {new Date(item.createdAt).toLocaleDateString()}{" "}
                          {new Date(item.createdAt).toLocaleTimeString()}
                        </p>
                        <div className="flex-row">
                          {role === "researcher" ? (
                            <button
                              className="request-download"
                              onClick={() => handleViewRequest(item)}
                            >
                              View & Submit
                            </button>
                          ) : (
                            <button
                              className="request-download"
                              onClick={() => handleViewRequest(item)}
                            >
                              View
                            </button>
                          )}
                        </div>
                      </div>
                      <div
                        className={`request-status ${getStatusClass(
                          item.status
                        )}`}
                      >
                        {role === "admin" && item.status === "Submitted" ? (
                          <div>
                            <button
                              className="reject-button"
                              onClick={() =>
                                handleRejectRequest(item.userId, item.matchId)
                              }
                            >
                              Reject
                            </button>
                            <button
                              onClick={() =>
                                handleApproveRequest(item.userId, item.matchId)
                              }
                              className="approve-button"
                            >
                              Approve
                            </button>
                          </div>
                        ) : (
                          item.status
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ) : (role === "researcher" || role === "admin") &&
              isBulkRequests ? (
              <div>
                {bulkRequests.map((item, index) => (
                  <div className="bulk-request-item" key={index}>
                    <div>
                      <p className="msg-request">
                        You have received a bulk new request from{" "}
                        <span style={{ fontWeight: "bold", color: "#000" }}>
                          {item.userName}
                        </span>{" "}
                        <span>({item.userEmail})</span>
                      </p>
                      <p className="review-request">
                        Please review the requested details, including
                        Technology Details, Job Openings, and News & Insights.
                      </p>
                      <p className="date-request">
                        {new Date(item.createdAt).toLocaleDateString()}{" "}
                        {new Date(item.createdAt).toLocaleTimeString()}
                      </p>
                      <div className="flex-row">
                        <button
                          onClick={() => handleDownloadBulkFile()}
                          className="request-download"
                        >
                          Download
                        </button>
                        {role === "researcher" &&
                          role !== "admin" &&
                          item.status === "Pending" && (
                            <div className="file-upload">
                              <input
                                type="file"
                                onChange={handleBulkFileChange}
                              />
                              <button
                                className="request-download"
                                onClick={() => handleUploadFile(item._id)}
                              >
                                Upload
                              </button>
                            </div>
                          )}
                      </div>
                    </div>
                    <div
                      className={`request-status ${getBulkStatusClass(
                        item.status
                      )}`}
                    >
                      {role === "admin" && item.status === "Submitted" ? (
                        <div className="approve-reject">
                          <button
                            className="reject-button"
                            onClick={() => handleRejectBulkRequest(item.userId)}
                          >
                            Reject
                          </button>
                          <button
                            onClick={() =>
                              handleApproveBulkRequest(item.userId)
                            }
                            className="approve-button"
                          >
                            Approve
                          </button>
                        </div>
                      ) : (
                        item.status
                      )}
                    </div>
                  </div>
                ))}
              </div>
            ) : (role === "admin" || "researcher") && isResearchRequests ? (
              <div>
                {researchRequest.map((item, index) => (
                  <div className="bulk-request-item" key={index}>
                    <div>
                      <p className="msg-request">
                        You have received a research request from{" "}
                        <span style={{ fontWeight: "bold", color: "#000" }}>
                          {item.userName}
                        </span>{" "}
                        <span>({item.userEmail})</span>
                      </p>
                      <p className="review-request">
                        Please review the requested fields
                      </p>
                      <p className="date-request">
                        {new Date(item.createdAt).toLocaleDateString()}{" "}
                        {new Date(item.createdAt).toLocaleTimeString()}
                      </p>
                      <div className="flex-row">
                        <button
                          onClick={() => handleViewResearch(item)}
                          className="request-download"
                        >
                          View
                        </button>
                      </div>
                    </div>
                    <div
                      className={`request-status ${getResearchStatusClass(
                        item.status
                      )}`}
                    >
                      {role === "admin" && item.status === "Submitted" ? (
                        <div className="approve-reject">
                          <button className="reject-button">Reject</button>
                          <button
                            onClick={() =>
                              handleApproveResearch(
                                research.userId,
                                research.matchId
                              )
                            }
                            className="approve-button"
                          >
                            Approve
                          </button>
                        </div>
                      ) : (
                        item.status
                      )}
                    </div>
                  </div>
                ))}
              </div>
            ) : (role === "admin" || "researcher") && isDataRequest ? (
              <div>
                {dataRequest.map((item, index) => (
                  <div className="bulk-request-item" key={index}>
                    <div>
                      <p className="msg-request">
                        You have received a data request
                        <span style={{ fontWeight: "bold", color: "#000" }}>
                          {item.userName}
                        </span>
                      </p>
                      <p className="review-request">
                        Please review the requested data request details and
                        approve.
                      </p>
                      <p className="date-request">
                        {new Date(item.createdAt).toLocaleDateString()}{" "}
                        {new Date(item.createdAt).toLocaleTimeString()}
                      </p>
                      <div className="flex-row">
                        <button
                          onClick={() =>
                            handleDownloadDataRequest(
                              item.adminId,
                              item.fileName
                            )
                          }
                          className="request-download"
                        >
                          {item.fileName}
                          <IoMdDownload />
                        </button>
                      </div>
                    </div>
                    <div
                      className={`request-status ${getDataStatusClass(
                        item.status
                      )}`}
                    >
                      {role === "admin" && item.status === "Verified" ? (
                        <div className="approve-reject">
                          <button className="reject-button">Reject</button>
                          <button
                            className="approve-button"
                            onClick={() => handleApproveDataRequest(item)}
                          >
                            Approve
                          </button>
                        </div>
                      ) : (
                        <button
                          className="verify-button"
                          onClick={() => {
                            if (role === "researcher") {
                              handleVerifyRequest(item._id);
                            }
                          }}
                        >
                          {item.status === "Pending" ? "Verify" : item.status}
                        </button>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            ) : (role === "researcher" || role === "admin") && isEditRequest ? (
              <div>
                {editRequest.map((item, index) => (
                  <div className="bulk-request-item" key={index}>
                    <div>
                      <p className="msg-request">
                        You have received a Edit request from
                        <span style={{ fontWeight: "bold", color: "#000" }}>
                          &nbsp;{item.userName}
                        </span>
                      </p>
                      <p className="review-request">
                        Please review the requested Edit request details and
                        approve.
                      </p>
                      <p className="date-request">
                        {new Date(item.createdAt).toLocaleDateString()}{" "}
                        {new Date(item.createdAt).toLocaleTimeString()}
                      </p>
                      <div className="flex-row">
                        <button
                          onClick={() => handleViewEditRequest(item)}
                          className="request-download"
                        >
                          View
                        </button>
                      </div>
                    </div>
                    <div
                      className={`request-status ${getEditStatusClass(
                        item.status
                      )}`}
                    >
                      {role === "admin" ? (
                        <div className="approve-reject">
                          {item.status === "Rejected" ? (
                            <button className="reject-button" disabled>
                              Rejected
                            </button>
                          ) : (
                            <div>
                              <button
                                onClick={() => handleRejectEditRequest(item)}
                                className="reject-button"
                              >
                                Reject
                              </button>
                              <button
                                onClick={() => handleSubmitEditRequest(item)}
                                className="approve-button"
                              >
                                Approve
                              </button>
                            </div>
                          )}
                        </div>
                      ) : (
                        <button
                          className="verify-button"
                          onClick={() => {
                            if (role === "researcher") {
                              handleVerifyRequest(item._id);
                            }
                          }}
                        >
                          {item.status === "Pending" ? "Verify" : item.status}
                        </button>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            ) : null}
            {showForm && selectedRequest && (
              <div className="add-popup">
                <div
                  className="overlay"
                  onClick={() => {
                    setShowForm(false);
                  }}
                ></div>
                <div className="add-popup-box">
                  <div className="add-heading">
                    <button
                      className="popup-close"
                      onClick={() => {
                        setShowForm(false);
                      }}
                    >
                      X
                    </button>
                    <h4>Update missing fields</h4>
                  </div>
                  <form
                    className="form-container"
                    onSubmit={handleSubmitDetails}
                  >
                    <div className="input-container-flex">
                      <div className="input-container">
                        <label htmlFor="name">First Name</label>
                        <input
                          type="text"
                          name="firstname"
                          placeholder="Enter name"
                          value={formData.firstname}
                          onChange={handleInputChange}
                        />
                      </div>
                      <div className="input-container">
                        <label htmlFor="name">Company Name</label>
                        <input
                          type="text"
                          name="companyname"
                          placeholder="Enter company name"
                          value={formData.companyname}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>
                    <div className="input-container-flex">
                      <div className="input-container">
                        <label htmlFor="linkedin">Linkedin Link</label>
                        <input
                          type="text"
                          name="linkedin"
                          placeholder="Enter linkedin link"
                          value={formData.linkedin}
                          onChange={handleInputChange}
                        />
                      </div>
                      <div className="input-container">
                        <label htmlFor="name">Email</label>
                        <input
                          type="email"
                          name="email"
                          placeholder="Enter email"
                          value={formData.email}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>

                    <div className="input-container-flex">
                      <div className="input-container">
                        <label htmlFor="designation">Designation</label>
                        <input
                          type="text"
                          name="designation"
                          placeholder="Designation"
                          value={formData.designation}
                          onChange={handleInputChange}
                        />
                      </div>
                      <div className="input-container">
                        <label htmlFor="phonenumber">Phone Number</label>
                        <input
                          type="number"
                          name="phonenumber"
                          placeholder="Phone Number"
                          value={formData.phonenumber}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>
                    <div className="input-container-flex">
                      <div className="input-container">
                        <label htmlFor="website">Website</label>
                        <input
                          type="text"
                          name="website"
                          placeholder="Website Link"
                          value={formData.website}
                          onChange={handleInputChange}
                        />
                      </div>
                      <div className="input-container">
                        <label htmlFor="designation">Company description</label>
                        <textarea
                          type="text"
                          name="companydescription"
                          placeholder="Company Description"
                          value={formData.companydescription}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>

                    <div className="input-container-flex">
                      <div className="input-container">
                        <label htmlFor="designation">City</label>
                        <input
                          type="text"
                          name="city"
                          placeholder="City"
                          value={formData.city}
                          onChange={handleInputChange}
                        />
                      </div>
                      <div className="input-container">
                        <label htmlFor="phonenumber">State</label>
                        <input
                          type="text"
                          name="state"
                          placeholder="State"
                          value={formData.state}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>

                    <div className="input-container-flex">
                      <div className="input-container">
                        <label htmlFor="country">Country</label>
                        <input
                          type="text"
                          name="country"
                          placeholder="Country"
                          value={formData.country}
                          onChange={handleInputChange}
                        />
                      </div>
                      <div className="input-container">
                        <label htmlFor="phonenumber">Industry</label>
                        <input
                          type="text"
                          name="industry"
                          placeholder="Industry"
                          value={formData.industry}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>

                    <div className="input-container-flex">
                      <div className="input-container">
                        <label htmlFor="designation">Annual Revenue</label>
                        <input
                          type="text"
                          name="annualrevenue"
                          placeholder="Annual Revenue"
                          value={formData.annualrevenue}
                          onChange={handleInputChange}
                        />
                      </div>
                      <div className="input-container">
                        <label htmlFor="phonenumber">No of Employees</label>
                        <input
                          type="number"
                          name="noofemployees"
                          placeholder="Employees"
                          value={formData.noofemployees}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>

                    <div className="input-container-flex">
                      <div className="input-container">
                        <label htmlFor="companylocation">
                          Company Location
                        </label>
                        <input
                          type="text"
                          name="companylocation"
                          placeholder="Company location"
                          value={formData.companylocation}
                          onChange={handleInputChange}
                        />
                      </div>
                      <div className="input-container">
                        <label htmlFor="designation">Headquarters</label>
                        <input
                          type="text"
                          name="headquarter"
                          placeholder="Head Quarter"
                          value={formData.headquarter}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>

                    <div className="input-container-flex">
                      <div className="input-container">
                        <label htmlFor="designation">Sub category</label>
                        <input
                          type="text"
                          name="subcategory"
                          placeholder="Sub category"
                          value={formData.subcategory}
                          onChange={handleInputChange}
                        />
                      </div>
                      <div className="input-container">
                        <label htmlFor="phonenumber">Type of Customer</label>
                        <input
                          type="text"
                          name="typeofCustomer"
                          placeholder="Type of customer"
                          value={formData.typeofCustomer}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>

                    <div className="input-container-flex">
                      <div className="input-container">
                        <label htmlFor="designation">Financial</label>
                        {formData.financial.map((finance, index) => (
                          <div
                            key={index}
                            className="input-container-flex"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "3px",
                            }}
                          >
                            <button
                              type="button"
                              className="remove-button"
                              onClick={() => removeFinancialForm(index)}
                              style={{
                                alignSelf: "flex-end",
                                cursor: "pointer",
                                border: "none",
                              }}
                            >
                              X
                            </button>
                            <input
                              type="text"
                              name="financialdescription"
                              placeholder="Financial Description"
                              value={finance.financialdescription}
                              onChange={(e) =>
                                handleFinanceFormChange(
                                  e,
                                  index,
                                  "financialdescription"
                                )
                              }
                            />
                            <input
                              type="text"
                              name="financialyear"
                              placeholder="Financial Year"
                              value={finance.financialyear}
                              onChange={(e) =>
                                handleFinanceFormChange(
                                  e,
                                  index,
                                  "financialyear"
                                )
                              }
                            />
                            <input
                              type="text"
                              name="financialsourcelink"
                              placeholder="Financial"
                              value={finance.financialsourcelink}
                              onChange={(e) =>
                                handleFinanceFormChange(
                                  e,
                                  index,
                                  "financialsourcelink"
                                )
                              }
                            />
                          </div>
                        ))}
                        <button
                          type="button"
                          className="add-more-field"
                          onClick={addFinancialForm}
                        >
                          + Add More
                        </button>
                      </div>
                      <div className="input-container">
                        <label htmlFor="phonenumber">Investors</label>
                        {formData.investors.map((invest, index) => (
                          <div
                            key={index}
                            className="input-container-flex"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "3px",
                            }}
                          >
                            <button
                              type="button"
                              className="remove-button"
                              onClick={() => removeInvestorForm(index)}
                              style={{
                                alignSelf: "flex-end",
                                cursor: "pointer",
                                border: "none",
                              }}
                            >
                              X
                            </button>
                            <input
                              type="text"
                              name="investors"
                              placeholder="Investors"
                              value={invest.investors}
                              onChange={(e) =>
                                handleInvestorFormChange(e, index, "investors")
                              }
                            />
                            <input
                              type="text"
                              name="investors"
                              placeholder="Investors"
                              value={invest.investorsourcelink}
                              onChange={(e) =>
                                handleInvestorFormChange(
                                  e,
                                  index,
                                  "investorsourcelink"
                                )
                              }
                            />
                          </div>
                        ))}
                        <button
                          type="button"
                          className="add-more-field"
                          onClick={addInvestorForm}
                        >
                          + Add More
                        </button>
                      </div>
                    </div>

                    <div className="input-container-flex">
                      <div className="input-container">
                        <label htmlFor="designation">Competitors</label>
                        <input
                          type="text"
                          name="competitors"
                          placeholder="competitors"
                          value={formData.competitors}
                          onChange={handleInputChange}
                        />
                      </div>
                      <div className="input-container">
                        <label htmlFor="partner">Partners</label>
                        <input
                          type="text"
                          name="partners"
                          placeholder="Partners"
                          value={formData.partners}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>
                    <div className="input-container-flex">
                      <div className="input-container">
                        <label htmlFor="technologydetails">
                          Technology Details
                          <span style={{ color: "red", margin: "0px 2px" }}>
                            *
                          </span>
                        </label>
                        <input
                          type="text"
                          name="technologydetails"
                          placeholder="Technology details"
                          value={formData.technologydetails}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                    </div>
                    <div className="input-container-flex">
                      <div className="input-container">
                        <label htmlFor="jobopenings">
                          Job Openings
                          <span style={{ color: "red", margin: "0px 2px" }}>
                            *
                          </span>
                        </label>
                        {formData.jobopenings.map((job, index) => (
                          <div
                            key={index}
                            className="input-container-flex"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "3px",
                            }}
                          >
                            {formData.newsandsocialinsights.length > 1 && (
                              <button
                                type="button"
                                className="remove-button"
                                onClick={() => removeJobOpeningForm(index)}
                                style={{
                                  alignSelf: "flex-end",
                                  cursor: "pointer",
                                  border: "none",
                                }}
                              >
                                X
                              </button>
                            )}
                            <input
                              type="text"
                              name="jobname"
                              placeholder="Job Title"
                              value={job.jobname}
                              onChange={(e) =>
                                handleJobFormChange(e, index, "jobname")
                              }
                              required
                            />
                            <input
                              type="text"
                              name="jobdescription"
                              placeholder="Job Description"
                              value={job.jobdescription}
                              onChange={(e) =>
                                handleJobFormChange(e, index, "jobdescription")
                              }
                              required
                            />
                            <input
                              type="text"
                              name="jobsource"
                              placeholder="Job Link"
                              value={job.jobsource}
                              onChange={(e) =>
                                handleJobFormChange(e, index, "jobsource")
                              }
                              required
                            />
                          </div>
                        ))}
                        <button
                          type="button"
                          className="add-more-field"
                          onClick={addJobOpeningForm}
                        >
                          + Add More
                        </button>
                      </div>
                      <div className="input-container">
                        <label htmlFor="newsandsocialinsights">
                          News and Social Insights
                          <span style={{ color: "red", margin: "0px 2px" }}>
                            *
                          </span>
                        </label>
                        {formData.newsandsocialinsights.map((news, index) => (
                          <div
                            key={index}
                            className="input-container-flex"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "3px",
                            }}
                          >
                            {formData.newsandsocialinsights.length > 1 && (
                              <button
                                type="button"
                                className="remove-button"
                                onClick={() => removeNewsForm(index)}
                                style={{
                                  alignSelf: "flex-end",
                                  cursor: "pointer",
                                  border: "none",
                                }}
                              >
                                X
                              </button>
                            )}
                            <input
                              type="text"
                              name="newsname"
                              placeholder="News Title"
                              value={news.newsname}
                              onChange={(e) =>
                                handleNewsFormChange(e, index, "newsname")
                              }
                              required
                            />
                            <input
                              type="text"
                              name="newsdescription"
                              placeholder="News Description"
                              value={news.newsdescription}
                              onChange={(e) =>
                                handleNewsFormChange(
                                  e,
                                  index,
                                  "newsdescription"
                                )
                              }
                              required
                            />
                            <input
                              type="text"
                              name="newssource"
                              placeholder="News Source"
                              value={news.newssource}
                              onChange={(e) =>
                                handleNewsFormChange(e, index, "newssource")
                              }
                              required
                            />
                          </div>
                        ))}
                        <button
                          type="button"
                          className="add-more-field"
                          onClick={addNewsForm}
                        >
                          + Add More
                        </button>
                      </div>
                    </div>
                    <div className="button-action">
                      <button
                        className="close-button"
                        onClick={() => setShowForm(false)}
                      >
                        Close
                      </button>
                      {role === "researcher" && (
                        <button className="add-button" type="submit">
                          Submit
                        </button>
                      )}
                    </div>
                  </form>
                </div>
              </div>
            )}

            {showMissingFieldsPopup && (
              <div className="popup-overlay">
                <div className="popup">
                  <h2>⚠️ Missing Required Fields</h2>
                  <p>The following required fields are missing:</p>
                  <ul>
                    {missingFields.map((field, index) => (
                      <li key={index}>{field}</li>
                    ))}
                  </ul>
                  <div className="popup-buttons-upload">
                    <button onClick={handleCancelUpload}>Cancel</button>
                    <button onClick={handleProceedUpload}>Proceed</button>
                  </div>
                </div>
              </div>
            )}

            {showPopup && (
              <div className="upload-popup">
                <div
                  className="popup-overlay"
                  onClick={() => setShowPopup(false)}
                >
                  <div
                    className="popup-grid"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <button
                      className="popup-close"
                      onClick={() => setShowPopup(false)}
                    >
                      X
                    </button>
                    <h2 className="revenuintel-matching">Revenuintel</h2>
                    <div className="matching-container">
                      {excelHeaders.map((uploadedHeader, index) => (
                        <div key={index} className="matching-row">
                          <span className="uploaded-header">
                            {uploadedHeader}
                          </span>
                          <span className="match-arrow">→</span>
                          <select
                            value={selectedFields[uploadedHeader] || ""}
                            onChange={(e) =>
                              handleMappingChange(
                                uploadedHeader,
                                e.target.value
                              )
                            }
                          >
                            <option value="">Select Header</option>
                            {requiredHeaders.map((requiredHeader, idx) => {
                              // Check if this header is already selected
                              const isSelected =
                                Object.values(selectedFields).includes(
                                  requiredHeader
                                );

                              return (
                                <option
                                  key={idx}
                                  value={requiredHeader}
                                  disabled={isSelected}
                                >
                                  {requiredHeader}
                                </option>
                              );
                            })}
                          </select>
                        </div>
                      ))}
                    </div>
                    <button
                      className="popup-submit"
                      onClick={handleCheckMissingFields}
                    >
                      Apply Mapping
                    </button>
                  </div>
                </div>
              </div>
            )}

            {(isAdd || editMode) && (
              <div className="add-popup">
                <div className="overlay" onClick={handleCloseOverlay}></div>
                <div className="add-popup-box">
                  <div className="add-heading">
                    <button
                      className="popup-close"
                      onClick={handleCloseOverlay}
                    >
                      X
                    </button>
                    {isAdd ? (
                      <h4>Add Contact Details</h4>
                    ) : editMode ? (
                      <h4>Edit Contact Details</h4>
                    ) : (
                      <h4>Add Contact Details</h4>
                    )}
                  </div>
                  <form className="form-container" onSubmit={handleSubmit}>
                    <div className="input-container-flex">
                      <div className="input-container">
                        <label htmlFor="name">First Name</label>
                        <input
                          type="text"
                          name="firstname"
                          placeholder="Enter name"
                          value={details.firstname}
                          onChange={handleOnChange}
                          required
                        />
                      </div>
                      <div className="input-container">
                        <label htmlFor="name">Company Name</label>
                        <input
                          type="text"
                          name="companyname"
                          placeholder="Enter company name"
                          value={details.companyname}
                          onChange={handleOnChange}
                          required
                        />
                      </div>
                    </div>
                    <div className="input-container-flex">
                      <div className="input-container">
                        <label htmlFor="linkedin">Linkedin Link</label>
                        <input
                          type="text"
                          name="linkedin"
                          placeholder="Enter linkedin link"
                          value={details.linkedin}
                          onChange={handleOnChange}
                        />
                      </div>
                      <div className="input-container">
                        <label htmlFor="name">Email</label>
                        <input
                          type="email"
                          name="email"
                          placeholder="Enter email"
                          value={details.email}
                          onChange={handleOnChange}
                          required
                        />
                      </div>
                    </div>
                    <div className="input-container-flex">
                      <div className="input-container">
                        <label htmlFor="designation">Designation</label>
                        <input
                          type="text"
                          name="designation"
                          placeholder="Designation"
                          value={details.designation}
                          onChange={handleOnChange}
                        />
                      </div>
                      <div className="input-container">
                        <label htmlFor="phonenumber">Phone Number</label>
                        <input
                          type="number"
                          name="phonenumber"
                          placeholder="Phone Number"
                          value={details.phonenumber}
                          onChange={handleOnChange}
                        />
                      </div>
                    </div>
                    <div className="input-container-flex">
                      <div className="input-container">
                        <label htmlFor="website">Website</label>
                        <input
                          type="text"
                          name="website"
                          placeholder="Website Link"
                          value={details.website}
                          onChange={handleOnChange}
                        />
                      </div>
                      <div className="input-container">
                        <label htmlFor="designation">Company description</label>
                        <textarea
                          type="text"
                          name="companydescription"
                          placeholder="Company Description"
                          value={details.companydescription}
                          onChange={handleOnChange}
                        />
                      </div>
                    </div>

                    <div className="input-container-flex">
                      <div className="input-container">
                        <label htmlFor="designation">City</label>
                        <input
                          type="text"
                          name="city"
                          placeholder="City"
                          value={details.city}
                          onChange={handleOnChange}
                        />
                      </div>
                      <div className="input-container">
                        <label htmlFor="phonenumber">State</label>
                        <input
                          type="text"
                          name="state"
                          placeholder="State"
                          value={details.state}
                          onChange={handleOnChange}
                        />
                      </div>
                    </div>

                    <div className="input-container-flex">
                      <div className="input-container">
                        <label htmlFor="country">Country</label>
                        <input
                          type="text"
                          name="country"
                          placeholder="Country"
                          value={details.country}
                          onChange={handleOnChange}
                        />
                      </div>
                      <div className="input-container">
                        <label htmlFor="phonenumber">Industry</label>
                        <input
                          type="text"
                          name="industry"
                          placeholder="Industry"
                          value={details.industry}
                          onChange={handleOnChange}
                        />
                      </div>
                    </div>

                    <div className="input-container-flex">
                      <div className="input-container">
                        <label htmlFor="designation">Annual Revenue</label>
                        <input
                          type="text"
                          name="annualrevenue"
                          placeholder="Annual Revenue"
                          value={details.annualrevenue}
                          onChange={handleOnChange}
                        />
                      </div>
                      <div className="input-container">
                        <label htmlFor="phonenumber">No of Employees</label>
                        <input
                          type="number"
                          name="noofemployees"
                          placeholder="Employees"
                          value={details.noofemployees}
                          onChange={handleOnChange}
                        />
                      </div>
                    </div>

                    <div className="input-container-flex">
                      <div className="input-container">
                        <label htmlFor="companylocation">
                          Company Location
                        </label>
                        <input
                          type="text"
                          name="companylocation"
                          placeholder="Company location"
                          value={details.companylocation}
                          onChange={handleOnChange}
                        />
                      </div>
                      <div className="input-container">
                        <label htmlFor="designation">Headquarters</label>
                        <input
                          type="text"
                          name="headquarter"
                          placeholder="Head Quarter"
                          value={details.headquarter}
                          onChange={handleOnChange}
                        />
                      </div>
                    </div>

                    <div className="input-container-flex">
                      <div className="input-container">
                        <label htmlFor="subcategory">Sub category</label>
                        <input
                          type="text"
                          name="subcategory"
                          placeholder="Sub category"
                          value={details.subcategory}
                          onChange={handleOnChange}
                        />
                      </div>
                      <div className="input-container">
                        <label htmlFor="typeofcustomer">Type of Customer</label>
                        <input
                          type="text"
                          name="typeofCustomer"
                          placeholder="Type of customer"
                          value={details.typeofCustomer}
                          onChange={handleOnChange}
                        />
                      </div>
                    </div>

                    <div className="input-container-flex">
                      <div className="input-container">
                        <label htmlFor="financial">Financial</label>
                        {details.financial.map((finance, index) => (
                          <div
                            key={index}
                            className="input-container-flex"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "3px",
                            }}
                          >
                            <button
                              type="button"
                              className="remove-button"
                              onClick={() => removeFinancial(index)}
                              style={{
                                alignSelf: "flex-end",
                                cursor: "pointer",
                                border: "none",
                              }}
                            >
                              X
                            </button>
                            <input
                              type="text"
                              name="financialdescription"
                              placeholder="Financial"
                              value={finance.financialdescription}
                              onChange={(e) =>
                                handleFinanceChange(
                                  e,
                                  index,
                                  "financialdescription"
                                )
                              }
                            />
                            <input
                              type="text"
                              name="financialyear"
                              placeholder="Financial Year"
                              value={finance.financialyear}
                              onChange={(e) =>
                                handleFinanceChange(e, index, "financialyear")
                              }
                            />
                            <input
                              type="text"
                              name="financialsourcelink"
                              placeholder="Financial Source Link"
                              value={finance.financialsourcelink}
                              onChange={(e) =>
                                handleFinanceChange(
                                  e,
                                  index,
                                  "financialsourcelink"
                                )
                              }
                            />
                          </div>
                        ))}
                        <button
                          type="button"
                          className="add-more-field"
                          onClick={addFinancial}
                        >
                          + Add More
                        </button>
                      </div>
                      <div className="input-container">
                        <label htmlFor="phonenumber">Investors</label>
                        {details.investors.map((invest, index) => (
                          <div
                            key={index}
                            className="input-container-flex"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "3px",
                            }}
                          >
                            <button
                              type="button"
                              className="remove-button"
                              onClick={() => removeInvestor(index)}
                              style={{
                                alignSelf: "flex-end",
                                cursor: "pointer",
                                border: "none",
                              }}
                            >
                              X
                            </button>
                            <input
                              type="text"
                              name="investors"
                              placeholder="Investors"
                              value={invest.investors}
                              onChange={(e) =>
                                handleInvestorChange(e, index, "investors")
                              }
                            />
                            <input
                              type="text"
                              name="investors"
                              placeholder="Investors"
                              value={invest.investorsourcelink}
                              onChange={(e) =>
                                handleInvestorChange(
                                  e,
                                  index,
                                  "investorsourcelink"
                                )
                              }
                            />
                          </div>
                        ))}
                        <button
                          type="button"
                          className="add-more-field"
                          onClick={addInvestor}
                        >
                          + Add More
                        </button>
                      </div>
                    </div>

                    <div className="input-container-flex">
                      <div className="input-container">
                        <label htmlFor="designation">Competitors</label>
                        <input
                          type="text"
                          name="competitors"
                          placeholder="competitors"
                          value={details.competitors}
                          onChange={handleOnChange}
                        />
                      </div>
                      <div className="input-container">
                        <label htmlFor="partner">Partners</label>
                        <input
                          type="text"
                          name="partners"
                          placeholder="Partners"
                          value={details.partners}
                          onChange={handleOnChange}
                        />
                      </div>
                    </div>
                    <div className="input-container-flex">
                      <div className="input-container">
                        <label htmlFor="followers">Followers</label>
                        <input
                          type="text"
                          name="followers"
                          placeholder="Followers"
                          value={details.followers}
                          onChange={handleOnChange}
                        />
                      </div>
                      <div className="input-container">
                        <label htmlFor="technologydetails">
                          Technology Details
                        </label>
                        <input
                          type="text"
                          name="technologydetails"
                          placeholder="Technology Details"
                          value={details.technologydetails}
                          onChange={handleOnChange}
                        />
                      </div>
                    </div>
                    <div className="input-container-flex">
                      <div className="input-container">
                        <label htmlFor="jobopenings">Job Openings</label>
                        {details.jobopenings.map((job, index) => (
                          <div
                            key={index}
                            className="input-container-flex"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "3px",
                            }}
                          >
                            <button
                              type="button"
                              className="remove-button"
                              onClick={() => removeJobOpening(index)}
                              style={{
                                alignSelf: "flex-end",
                                cursor: "pointer",
                                border: "none",
                              }}
                            >
                              X
                            </button>
                            <input
                              type="text"
                              name="jobname"
                              placeholder="Job Title"
                              value={job.jobname}
                              onChange={(e) =>
                                handleJobChange(e, index, "jobname")
                              }
                            />
                            <input
                              type="text"
                              name="jobdescription"
                              placeholder="Job Description"
                              value={job.jobdescription}
                              onChange={(e) =>
                                handleJobChange(e, index, "jobdescription")
                              }
                            />
                            <input
                              type="text"
                              name="jobsource"
                              placeholder="Job Link"
                              value={job.jobsource}
                              onChange={(e) =>
                                handleJobChange(e, index, "jobsource")
                              }
                            />
                          {details.jobopenings.length > 1 && (
                          <button
                            type="button"
                            onClick={() => removeJobOpening(index)}
                            style={{ background: "red", color: "white", marginTop: "5px" }}
                          >
                            Remove
                          </button>
                        )}
                        </div>
                        ))}
                        
                        <button
                          type="button"
                          className="add-more-field"
                          onClick={addJobOpening}
                        >
                          + Add More
                        </button>
                      </div>
                      <div className="input-container">
                        <label htmlFor="newsandsocialinsights">
                          News and Social Insights
                        </label>
                        {details.newsandsocialinsights.map((news, index) => (
                          <div
                            key={index}
                            className="input-container-flex"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "3px",
                            }}
                          >
                            <button
                              type="button"
                              className="remove-button"
                              onClick={() => removeNews(index)}
                              style={{
                                alignSelf: "flex-end",
                                cursor: "pointer",
                                border: "none",
                              }}
                            >
                              X
                            </button>
                            <input
                              type="text"
                              name="newsname"
                              placeholder="News Title"
                              value={news.newsname}
                              onChange={(e) =>
                                handleNewsChange(e, index, "newsname")
                              }
                            />
                            <input
                              type="text"
                              name="newsdescription"
                              placeholder="News Description"
                              value={news.newsdescription}
                              onChange={(e) =>
                                handleNewsChange(e, index, "newsdescription")
                              }
                            />
                            <input
                              type="text"
                              name="newssource"
                              placeholder="News Source"
                              value={news.newssource}
                              onChange={(e) =>
                                handleNewsChange(e, index, "newssource")
                              }
                            />
                          </div>
                        ))}
                        <button
                          type="button"
                          className="add-more-field"
                          onClick={addNews}
                        >
                          + Add More
                        </button>
                      </div>
                    </div>
                    <div className="button-action">
                      <button
                        className="close-button"
                        onClick={handleCloseOverlay}
                      >
                        Close
                      </button>
                      <button className="add-button" type="submit">
                        {editMode ? "Update" : "Add"}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            )}

            {isResearch && (
              <div className="add-popup">
                <div
                  className="overlay"
                  onClick={() => {
                    setIsResearch(false);
                  }}
                ></div>
                <div className="add-popup-box">
                  <div className="add-heading">
                    <button
                      className="popup-close"
                      onClick={() => setIsResearch(false)}
                    >
                      X
                    </button>
                    <h4>Add Fields for Research</h4>
                  </div>
                  <form
                    className="form-container"
                    onSubmit={(e) => {
                      e.preventDefault();
                      if (role === "researcher") {
                        handleSubmitResearch(e);
                      } else if (role === "admin") {
                        handleApproveResearch(
                          research.userId,
                          research.matchId
                        );
                      } else {
                        handleSendResearch(e);
                      }
                    }}
                  >
                    <div className="input-container-flex">
                      <div className="input-container">
                        <label htmlFor="name">First Name</label>
                        <input
                          type="text"
                          name="firstname"
                          placeholder="Enter name"
                          value={research.firstname}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="input-container">
                        <label htmlFor="name">Company Name</label>
                        <input
                          type="text"
                          name="companyname"
                          placeholder="Enter company name"
                          value={research.companyname}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="input-container-flex">
                      <div className="input-container">
                        <label htmlFor="linkedin">Linkedin Link</label>
                        <input
                          type="text"
                          name="linkedin"
                          placeholder="Enter linkedin link"
                          value={research.linkedin}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="input-container">
                        <label htmlFor="name">Email</label>
                        <input
                          type="email"
                          name="email"
                          placeholder="Enter email"
                          value={research.email}
                          onChange={handleChange}
                        />
                      </div>
                    </div>

                    <div className="input-container-flex">
                      <div className="input-container">
                        <label htmlFor="designation">Designation</label>
                        <input
                          type="text"
                          name="designation"
                          placeholder="Designation"
                          value={research.designation}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="input-container">
                        <label htmlFor="phonenumber">Phone Number</label>
                        <input
                          type="number"
                          name="phonenumber"
                          placeholder="Phone Number"
                          value={research.phonenumber}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="input-container-flex">
                      <div className="input-container">
                        <label htmlFor="website">Website</label>
                        <input
                          type="text"
                          name="website"
                          placeholder="Website Link"
                          value={research.website}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="input-container">
                        <label htmlFor="designation">Company description</label>
                        <textarea
                          type="text"
                          name="companydescription"
                          placeholder="Company Description"
                          value={research.companydescription}
                          onChange={handleChange}
                        />
                      </div>
                    </div>

                    <div className="input-container-flex">
                      <div className="input-container">
                        <label htmlFor="designation">City</label>
                        <input
                          type="text"
                          name="city"
                          placeholder="City"
                          value={research.city}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="input-container">
                        <label htmlFor="phonenumber">State</label>
                        <input
                          type="text"
                          name="state"
                          placeholder="State"
                          value={research.state}
                          onChange={handleChange}
                        />
                      </div>
                    </div>

                    <div className="input-container-flex">
                      <div className="input-container">
                        <label htmlFor="country">Country</label>
                        <input
                          type="text"
                          name="country"
                          placeholder="Country"
                          value={research.country}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="input-container">
                        <label htmlFor="phonenumber">Industry</label>
                        <input
                          type="text"
                          name="industry"
                          placeholder="Industry"
                          value={research.industry}
                          onChange={handleChange}
                        />
                      </div>
                    </div>

                    <div className="input-container-flex">
                      <div className="input-container">
                        <label htmlFor="designation">Annual Revenue</label>
                        <input
                          type="text"
                          name="annualrevenue"
                          placeholder="Annual Revenue"
                          value={research.annualrevenue}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="input-container">
                        <label htmlFor="phonenumber">No of Employees</label>
                        <input
                          type="number"
                          name="noofemployees"
                          placeholder="Employees"
                          value={research.noofemployees}
                          onChange={handleChange}
                        />
                      </div>
                    </div>

                    <div className="input-container-flex">
                      <div className="input-container">
                        <label htmlFor="companylocation">
                          Company Location
                        </label>
                        <input
                          type="text"
                          name="companylocation"
                          placeholder="Company location"
                          value={research.companylocation}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="input-container">
                        <label htmlFor="designation">Headquarters</label>
                        <input
                          type="text"
                          name="headquarter"
                          placeholder="Head Quarter"
                          value={research.headquarter}
                          onChange={handleChange}
                        />
                      </div>
                    </div>

                    <div className="input-container-flex">
                      <div className="input-container">
                        <label htmlFor="designation">Sub category</label>
                        <input
                          type="text"
                          name="subcategory"
                          placeholder="Sub category"
                          value={research.subcategory}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="input-container">
                        <label htmlFor="phonenumber">Type of Customer</label>
                        <input
                          type="text"
                          name="typeofCustomer"
                          placeholder="Type of customer"
                          value={research.typeofCustomer}
                          onChange={handleChange}
                        />
                      </div>
                    </div>

                    <div className="input-container-flex">
                      <div className="input-container">
                        <label htmlFor="designation">Financial</label>
                        {research?.financial?.map((finance, index) => (
                          <div
                            key={index}
                            className="input-container-flex"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "3px",
                            }}
                          >
                            <br />
                            <input
                              type="text"
                              name="financialdescription"
                              placeholder="Financial"
                              value={finance.financialdescription}
                              onChange={(e) =>
                                handleFinanceChange(
                                  e,
                                  index,
                                  "financialdescription"
                                )
                              }
                            />
                            <input
                              type="text"
                              name="financialyear"
                              placeholder="Financial Description"
                              value={finance.financialyear}
                              onChange={(e) =>
                                handleFinanceChange(e, index, "financialyear")
                              }
                            />
                            <input
                              type="text"
                              name="financialsourcelink"
                              placeholder="Financial Year"
                              value={finance.financialsourcelink}
                              onChange={(e) =>
                                handleFinanceChange(
                                  e,
                                  index,
                                  "financialsourcelink"
                                )
                              }
                            />
                          </div>
                        ))}
                        <button
                          type="button"
                          className="add-more-field"
                          onClick={addFinancial}
                        >
                          + Add More
                        </button>
                      </div>
                      <div className="input-container">
                        <label htmlFor="phonenumber">Investors</label>
                        {research?.investors?.map((invest, index) => (
                          <div
                            key={index}
                            className="input-container-flex"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "3px",
                            }}
                          >
                            <br />
                            <input
                              type="text"
                              name="investors"
                              placeholder="Investors"
                              value={invest.investors}
                              onChange={(e) =>
                                handleInvestorChange(e, index, "investors")
                              }
                            />
                            <input
                              type="text"
                              name="investors"
                              placeholder="Investors"
                              value={invest.investorsourcelink}
                              onChange={(e) =>
                                handleInvestorChange(
                                  e,
                                  index,
                                  "investorsourcelink"
                                )
                              }
                            />
                          </div>
                        ))}
                        <button
                          type="button"
                          className="add-more-field"
                          onClick={addInvestor}
                        >
                          + Add More
                        </button>
                      </div>
                    </div>

                    <div className="input-container-flex">
                      <div className="input-container">
                        <label htmlFor="designation">Competitors</label>
                        <input
                          type="text"
                          name="competitors"
                          placeholder="competitors"
                          value={research.competitors}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="input-container">
                        <label htmlFor="partner">Partners</label>
                        <input
                          type="text"
                          name="partners"
                          placeholder="Partners"
                          value={research.partners}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="input-container-flex">
                      <div className="input-container">
                        <label htmlFor="followers">Followers</label>
                        <input
                          type="text"
                          name="followers"
                          placeholder="Followers"
                          value={research.followers}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="input-container">
                        <label htmlFor="technologydetails">
                          Technology Details
                        </label>
                        <input
                          type="text"
                          name="technologydetails"
                          placeholder="Technology details"
                          value={research.technologydetails}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="input-container-flex">
                      <div className="input-container">
                        <label htmlFor="jobopenings">Job Openings</label>
                        {research?.jobopenings?.map((job, index) => (
                          <div
                            key={index}
                            className="input-container-flex"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "3px",
                            }}
                          >
                            <br />
                            <input
                              type="text"
                              name="jobname"
                              placeholder="Job Title"
                              value={job.jobname}
                              onChange={(e) =>
                                handleJobChange(e, index, "jobname")
                              }
                            />
                            <input
                              type="text"
                              name="jobdescription"
                              placeholder="Job Description"
                              value={job.jobdescription}
                              onChange={(e) =>
                                handleJobChange(e, index, "jobdescription")
                              }
                            />
                            <input
                              type="text"
                              name="jobsource"
                              placeholder="Job Link"
                              value={job.jobsource}
                              onChange={(e) =>
                                handleJobChange(e, index, "jobsource")
                              }
                            />
                          </div>
                        ))}
                        <button
                          type="button"
                          className="add-more-field"
                          onClick={addJobOpening}
                        >
                          + Add More
                        </button>
                      </div>
                      <div className="input-container">
                        <label htmlFor="newsandsocialinsights">
                          News and Social Insights
                        </label>
                        {research?.newsandsocialinsights?.map((news, index) => (
                          <div
                            key={index}
                            className="input-container-flex"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "3px",
                            }}
                          >
                            <br />
                            <input
                              type="text"
                              name="newsname"
                              placeholder="News Title"
                              value={news.newsname}
                              onChange={(e) =>
                                handleNewsChange(e, index, "newsname")
                              }
                            />
                            <input
                              type="text"
                              name="newsdescription"
                              placeholder="News Description"
                              value={news.newsdescription}
                              onChange={(e) =>
                                handleNewsChange(e, index, "newsdescription")
                              }
                            />
                            <input
                              type="text"
                              name="newssource"
                              placeholder="News Source"
                              value={news.newssource}
                              onChange={(e) =>
                                handleNewsChange(e, index, "newssource")
                              }
                            />
                          </div>
                        ))}
                        <button
                          type="button"
                          className="add-more-field"
                          onClick={addNews}
                        >
                          + Add More
                        </button>
                      </div>
                    </div>

                    {/* Input for field label (only shows when Add Field is clicked) */}
                    {showLabelInput && (
                      <div className="input-container">
                        <input
                          type="text"
                          placeholder="Enter Field Label"
                          value={newFieldLabel}
                          onChange={(e) => setNewFieldLabel(e.target.value)}
                          onKeyDown={handleLabelSubmit}
                          autoFocus
                        />
                      </div>
                    )}
                    {research.extraFields?.length > 0 &&
                      research.extraFields.map((field, index) => (
                        <div key={index}>
                          {/* <button onClick={() => handleRemoveField(index)}>X</button> */}
                          <label>{field.label}</label>
                          <input
                            type="text"
                            value={field.value || ""}
                            onChange={(e) => handleFieldValueChange(e, index)}
                          />
                        </div>
                      ))}

                    <div className="button-action">
                      {role === "user" && (
                        <button
                          className="add-field"
                          type="button"
                          onClick={() => setShowLabelInput(true)}
                        >
                          Add Field
                        </button>
                      )}
                      <button className="add-button" type="submit">
                        {role === "researcher"
                          ? "Submit"
                          : role === "admin"
                          ? "Approve"
                          : "Send"}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            )}

            {isOpenProfile && (
              <div className="profile-popup">
                <div
                  className="overlay"
                  onClick={() => setIsOpenProfile(false)}
                ></div>
                <div className="profile-popup-box">
                  {data
                    .filter((item) => item._id === selectedItem?._id)
                    .map((item, index) => (
                      <div key={index}>
                        <div className="profile-box">
                          <div className="profile-container">
                            <div className="dwld-heart">
                              <div className="profile-icon">
                                <MdClose
                                  className="close-profile-icon"
                                  onClick={handleCloseProfile}
                                />
                              </div>
                            </div>
                            <div className="profile-image">
                              <div className="profile-image-tick">
                                {selectedItem.profileImage ? (
                                  <img src={EmptyImage} alt="Profile" />
                                ) : (
                                  <img src={EmptyImage} alt="default pic" />
                                )}
                                {visibleColumns.image &&
                                  visibleColumns.status && (
                                    <span className="active-icon">
                                      {item.status === "Active" ? (
                                        <VscPass
                                          className={getStatusprofile(
                                            item.status
                                          )}
                                        />
                                      ) : (
                                        <VscError
                                          className={getStatusprofile(
                                            item.status
                                          )}
                                        />
                                      )}
                                    </span>
                                  )}
                              </div>
                            </div>
                            <div className="dwld-btn">
                              <button
                                onClick={() => downloadPDF(item._id)}
                                style={{ width: "30px", borderRadius: "50%" }}
                              >
                                <IoMdDownload style={{ fontSize: "14px" }} />
                              </button>
                            </div>
                          </div>
                          <div className="profile-name">
                            {visibleColumns.firstname && (
                              <p style={{ textAlign: "center" }}>
                                {item.firstname}
                              </p>
                            )}
                          </div>
                          <div className="profile-role">
                            {visibleColumns.designation && (
                              <p style={{ textAlign: "center" }}>
                                {item.designation}
                                <span> @ {item.companyname}</span>
                              </p>
                            )}
                          </div>
                        </div>
                        <div className="profile-inside-container">
                          <div className="company-info">
                            <button
                              style={{
                                backgroundColor: companyColor,
                                color:
                                  companyColor === "#FCB124"
                                    ? "#fff"
                                    : "#FCB124",
                              }}
                              onClick={handleShowCompany}
                            >
                              Company Overview
                            </button>
                          </div>
                          <div className="profile-info">
                            <button
                              style={{
                                backgroundColor: techColor,
                                color:
                                  techColor === "#FCB124" ? "#fff" : "#FCB124",
                              }}
                              onClick={handleShowTechStack}
                            >
                              Technographics
                            </button>
                          </div>
                          <div className="profile-info">
                            <button
                              style={{
                                backgroundColor: contactColor,
                                color:
                                  contactColor === "#FCB124"
                                    ? "#fff"
                                    : "#FCB124",
                              }}
                              onClick={handleShowContact}
                            >
                              Decision Makers
                            </button>
                          </div>
                        </div>
                        <div className="profile-inside-container">
                          <div className="openings-info">
                            <button
                              style={{
                                backgroundColor: jobColor,
                                color:
                                  jobColor === "#FCB124" ? "#fff" : "#FCB124",
                              }}
                              onClick={handleShowOpenings}
                            >
                              Job Openings
                            </button>
                          </div>
                          <div className="openings-info">
                            <button
                              style={{
                                backgroundColor: accountColor,
                                color:
                                  accountColor === "#FCB124"
                                    ? "#fff"
                                    : "#FCB124",
                              }}
                              onClick={handleShowAccount}
                            >
                              News & Social Insights
                            </button>
                          </div>
                        </div>
                        {showCompany && (
                          <div className="company-details">
                            <div className="company-heading"></div>
                            <div className="company-overview">
                              {item.companyname && (
                                <li>
                                  🏢 <strong>Company Name:</strong>{" "}
                                  {item.companyname}
                                </li>
                              )}
                              {item.companydescription && (
                                <li>
                                  🏢 <strong>Description:</strong>{" "}
                                  {item.companydescription}
                                </li>
                              )}
                              {item.website && (
                                <li>
                                  🌐 <strong>Website: </strong>
                                  <a
                                    href={item.website}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    {item.website}
                                  </a>
                                </li>
                              )}
                              {item.headquarter && (
                                <li>
                                  📍 <strong>Headquarters:</strong>{" "}
                                  {item.headquarter}
                                </li>
                              )}
                              {item.industry && (
                                <li>
                                  🏭 <strong>Industry:</strong> {item.industry}
                                </li>
                              )}
                              {item.noofemployees && (
                                <li>
                                  👥 <strong>Employee Count:</strong>
                                  {item.noofemployees}
                                </li>
                              )}

                              {item.annualrevenue && (
                                <li>
                                  💰 <strong>Revenue:</strong>{" "}
                                  {item.annualrevenue}
                                </li>
                              )}
                            </div>
                          </div>
                        )}

                        {showTechstack && (
                          <div>
                            <div className="tech-heading">
                              <h3>💻Technology Details</h3>
                            </div>
                            <div className="tech-overview">
                              {item.technologydetails && (
                                <li>{item.technologydetails}</li>
                              )}
                            </div>
                          </div>
                        )}

                        {showContact && (
                          <div className="company-details">
                            <div className="company-heading">
                              <h3>Key Decision Makers</h3>
                            </div>
                            <div className="company-overview">
                              {(() => {
                                // First filter only by company name
                                const sameCompany = data.filter(
                                  (contact) =>
                                    contact.companyname ===
                                    selectedItem.companyname
                                );

                                const decisionMakers = sameCompany.filter(
                                  (contact) =>
                                    [
                                      "chief executive officer",
                                      "ceo",
                                      "chief financial officer",
                                      "cfo",
                                      "cto",
                                      "cmo",
                                      "chief technology officer",
                                      "vp engineering",
                                    ].includes(
                                      contact.designation?.toLowerCase()
                                    )
                                );

                                return decisionMakers.length > 0 ? (
                                  decisionMakers.map((contact, index) => (
                                    <li
                                      style={{ marginLeft: "30px" }}
                                      key={index}
                                    >
                                      👤 {contact.firstname} -{" "}
                                      {contact.designation}
                                    </li>
                                  ))
                                ) : (
                                  <p style={{ marginLeft: "30px" }}>
                                    Not Available
                                  </p>
                                );
                              })()}
                            </div>
                          </div>
                        )}

                        {showAccount && (
                          <div className="company-details">
                            <div className="company-heading">
                              <h3>📰 News & Social Insights</h3>
                            </div>
                            <div>
                              {item.newsandsocialinsights.length === 0 ? (
                                <div>
                                  <span>No News available</span>
                                </div>
                              ) : (
                                item.newsandsocialinsights?.map(
                                  (news, index) => {
                                    const isExpandedNews =
                                      expandedNewsIndex === index;

                                    // Truncate description if not expanded
                                    const displayText = isExpandedNews
                                      ? news.newsdescription
                                      : news.newsdescription.slice(0, 150) +
                                        "...";
                                    return (
                                      <div
                                        style={{ padding: "5px" }}
                                        className="news-item"
                                        key={index}
                                      >
                                        <h4
                                          style={{
                                            fontSize: "14px",
                                            margin: "0px",
                                          }}
                                        >
                                          {news.newsname}
                                        </h4>
                                        <p style={{ fontSize: "12px" }}>
                                          {displayText}
                                          {news.newsdescription.length >
                                            100 && (
                                            <span
                                              style={{
                                                color: "blue",
                                                cursor: "pointer",
                                              }}
                                              onClick={() =>
                                                setExpandedNewsIndex(
                                                  isExpandedNews ? null : index
                                                )
                                              }
                                            >
                                              {isExpandedNews
                                                ? "Read Less"
                                                : "Read More"}
                                            </span>
                                          )}
                                        </p>
                                        <p style={{ fontSize: "12px" }}>
                                          {" "}
                                          {new Date(
                                            item.createdAt
                                          ).toLocaleDateString()}
                                          &nbsp;{"|"}&nbsp;
                                          {new Date(
                                            item.createdAt
                                          ).toLocaleTimeString()}
                                          <span
                                            target="_blank"
                                            rel="noopener noreferrer"
                                          >
                                            {news.newssource}
                                          </span>
                                        </p>
                                      </div>
                                    );
                                  }
                                )
                              )}

                              {item.newsandsocialinsights.length > 1 && (
                                <button
                                  style={{
                                    backgroundColor: "#FCB124",
                                    border: "none",
                                    width: "150px",
                                    height: "30px",
                                    margin: "auto",
                                    top: "20px",
                                  }}
                                  className="show-more-btn"
                                  onClick={handleShowMoreNews}
                                >
                                  Show More News
                                </button>
                              )}
                            </div>
                          </div>
                        )}

                        {showOpenings && (
                          <div>
                            {item.jobopenings.length === 0 ? (
                              <div>
                                <span>No Jobs available</span>
                              </div>
                            ) : (
                              item.jobopenings.map((job, index) => {
                                const isExpandedJob =
                                  expandedJobIndex === index;

                                const displayText = isExpandedJob
                                  ? job.jobdescription
                                  : job.jobdescription.slice(0, 150) + "...";
                                return (
                                  <div className="job-details">
                                    <div className="job-container">
                                      <div key={index}>
                                        {job.jobname && (
                                          <h3 className="job-title">
                                            💼 {job.jobname}
                                          </h3>
                                        )}
                                        {job.jobdescription && (
                                          <p className="company-name">
                                            🏢 {displayText}
                                            {job.jobdescription.length >
                                              100 && (
                                              <span
                                                style={{
                                                  color: "blue",
                                                  cursor: "pointer",
                                                }}
                                                onClick={() =>
                                                  setExpandedJobIndex(
                                                    isExpandedJob ? null : index
                                                  )
                                                }
                                              >
                                                {isExpandedJob
                                                  ? "Read Less"
                                                  : "Read More"}
                                              </span>
                                            )}
                                          </p>
                                        )}
                                        {job.jobsource && (
                                          <p
                                            className="company-location"
                                            style={{
                                              color: "blue",
                                              cursor: "pointer",
                                            }}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                          >
                                            {" "}
                                            ℹ️ {job?.jobsource}
                                          </p>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                );
                              })
                            )}
                            {item.jobopenings.length > 3 && (
                              <div className="show-more">
                                <a href="#s">show more</a>
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Contacts;